// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios';  //引入axios
import VueAxios from 'vue-axios';  // 引入vue-axios
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/en'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
import Button from '@nutui/nutui/dist/packages/button/button.js';  // 加载构建后的JS
import '@nutui/nutui/dist/packages/button/button.css';  //加载构建后的CSS
import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';
Vue.use(VantGreen);
NutUI.install(Vue);
  // 安装 ElementUI（ui）
locale.use(lang)
Vue.use(ElementUI)
Vue.use(VueAxios,axios);  //使用
Vue.config.productionTip = false
Vue.prototype.$lujin='https://qrapi.hhlsoft.cn',//国内
//Vue.prototype.$lujin='https://qrcode.hlwxsys.com:999',
//Vue.prototype.$lujin='http://192.168.2.19:7009',
//Vue.prototype.$lujin='https://nodeapi.hlwxsys.com',//欧洲
Vue.prototype.$vipurl='https://apivip.hlwxsys.com',//会员
//Vue.prototype.$lujin='https://api.hlwxsys.com:999',//亚洲

Vue.prototype.$lang = [
  {
    l1: "点餐",
    l2: "餐厅电话",
    l3: "营业时间",
    l4: "语言选择",
    l5: "餐台号",
    l6: "搜索",
    l7: "返回",
    l8: "单位选择",
    l9: "套餐子项目",
    l10: "做法选择",
    l11: "加入购物车",
    l12: "知道了",
    l13: "做法",
    l14: "附加价",
    l15: "确定",
    l16: "取消",
    l17: "提示",
    l18: "购物车",
    l19: "全选",
    l20: "下单",
    l21: "是否删除",
    l22: "没有菜品",
    l23: "用餐时间",
    l24: "最大",
    l25: "确认下单吗",
    l26: "请先勾选菜品",
    l27: "菜品数量过多",
    l28: "下单中",
    l29: "下单失败",
    l30: "等待餐厅接单",
    l31: "餐厅未接单",
    l32: "餐台未开台",
    l33: "餐台正在结账",
    l34: "点餐次数超过可点次数",
    l35: "点菜数量大于可点数量",
    l36: "当前时间不在可点菜范围",
    l37: "点菜时间已过请重新开台",
    l38: "估清",
    l39: "餐厅未接单",
    l40: "做法选择",
    l41: "必须选择",
    l42: "最少选择",
    l43: "最多选择",
    l44: "请先选择",
    l45: "会员登录",
    l46: "登录",
    l47: "注册",
    l48: "请输入名称",
    l49: "获取验证码",
    l50: "请输入电子邮箱",
    l51: "请输入密码",
    l52: "是否退出当前会员登录",
    l53: "请输入正确的邮箱格式",
    l54: "请输入验证码",
    l55: "注册成功",
    l56: "验证码已发送",
    l57: "验证码发送失败",
    l58: "该邮箱已经注册",
    l59: "验证码校验错误",
    l60: "注册失败",
    l61: "会员不存在或密码错误",
    l62: "暂无可用优惠券",
    l63: "请先登录会员",
    l64: "清空",
    l65: "选择优惠券",
    l66: "最多可选",
    l67: "优惠券",
    l68: "优惠抵扣",
    l69: "完成",
    l70: "邮箱",
    l71: "密码",
    l72: "输入用户名称",
    l73: "输入电子邮箱",
    l74: "输入验证码",
    l75: "输入密码",
    l76: "已选",
    l77: "选择",
    l78: "添加成功",
    l79: "当前没有可用优惠券",
    l80: "部分优惠券已失效，已自动取消",
    l81: "最多可选择",
    l82: "张优惠券",
    l83: "当前订单金额未达到该优惠券使用条件",
    l84: "优惠金额不能大于订单金额",
    l85: "获取门店密钥失败",
    l86: "登录成功",
    l87: "登录失败",
    l88: "缺少会员消费单号",
    l89: "会员消费记录失败",
    l90: "缺少门店编号",
    l91: "门店密钥为空",
    l92: "门店密钥解析失败",
    l93: "当前浏览器不支持 AES 解密",
    l94: "门店未开通",
    l95: "请输入用户名称",
    l96: "支付链接生成失败",
    l97: "已达到最大可选数量",
    l98: "选项",
    l99: "参数错误",
    l100: "必填",
    l101: "优惠券",
    l102: "登录后可用",
    l103: "已选",
    l104: "张",
    l105: "可用",
    l106: "0张可用",
    l107: "不可用",
    l108: "当前订单可用",
    l109: "订单满",
    l110: "可用",
    l111: "自取",
    l112: "外卖",
    l113: "姓名",
    l114: "电话",
    l115: "邮编",
    l116: "地址",
    l117: "取餐时间",
    l118: "到达时间",
    l119: "选项必选",
    l120: "固定套餐",
    l121: "可选套餐选项",
    l122: "小费",
    l123: "菜品价格",
    l124: "服务费",
    l125: "打包费",
    l126: "份起",
    l127: "全部",
    l128: "含税",
    l129: "税前",
    l130: "请输入",
    l131: "自定义备注",
    l132: "请输入备注",
    l133: "备注",
    l134: "全选",
    l135: "合计",
    l136: "下单",
    l137: "获得成功->",
    l138: "解析好的",
    l139: "本页面仅显示您扫码下单的商品。如需查看完整账单，请返回并点击右下角图标",
  },
  {
    l1: "點餐",
    l2: "餐廳電話",
    l3: "營業時間",
    l4: "語言選擇",
    l5: "餐台號",
    l6: "搜索",
    l7: "返回",
    l8: "單位選擇",
    l9: "套餐子項目",
    l10: "做法選擇",
    l11: "加入購物車",
    l12: "知道了",
    l13: "做法",
    l14: "附加價",
    l15: "確定",
    l16: "取消",
    l17: "提示",
    l18: "購物車",
    l19: "全選",
    l20: "下單",
    l21: "是否刪除",
    l22: "沒有菜品",
    l23: "用餐時間",
    l24: "最大",
    l25: "確認下單嗎",
    l26: "請先勾選菜品",
    l27: "菜品數量過多",
    l28: "下單中",
    l29: "下單失敗",
    l30: "等待餐廳接單",
    l31: "餐廳未接單",
    l32: "餐台未開台",
    l33: "餐台正在結賬",
    l34: "點餐次數超過可點次數",
    l35: "點菜數量大於可點數量",
    l36: "當前時間不在可點菜範圍",
    l37: "點菜時間已過請重新開台",
    l38: "估清",
    l39: "餐廳未接單",
    l40: "做法選擇",
    l41: "必須選擇",
    l42: "最少選擇",
    l43: "最多選擇",
    l44: "請先選擇",
    l45: "會員登入",
    l46: "登入",
    l47: "註冊",
    l48: "請輸入名稱",
    l49: "取得驗證碼",
    l50: "請輸入電子郵箱",
    l51: "請輸入密碼",
    l52: "是否退出當前會員登入",
    l53: "請輸入正確的郵箱格式",
    l54: "請輸入驗證碼",
    l55: "註冊成功",
    l56: "驗證碼已發送",
    l57: "驗證碼發送失敗",
    l58: "該郵箱已經註冊",
    l59: "驗證碼校驗錯誤",
    l60: "註冊失敗",
    l61: "會員不存在或密碼錯誤",
    l62: "暫無可用優惠券",
    l63: "請先登入會員",
    l64: "清空",
    l65: "選擇優惠券",
    l66: "最多可選",
    l67: "優惠券",
    l68: "優惠抵扣",
    l69: "完成",
    l70: "郵箱",
    l71: "密碼",
    l72: "輸入用戶名稱",
    l73: "輸入電子郵箱",
    l74: "輸入驗證碼",
    l75: "輸入密碼",
    l76: "已選",
    l77: "選擇",
    l78: "添加成功",
    l79: "當前沒有可用優惠券",
    l80: "部分優惠券已失效，已自動取消",
    l81: "最多可選擇",
    l82: "張優惠券",
    l83: "當前訂單金額未達到該優惠券使用條件",
    l84: "優惠金額不能大於訂單金額",
    l85: "獲取門店密鑰失敗",
    l86: "登入成功",
    l87: "登入失敗",
    l88: "缺少會員消費單號",
    l89: "會員消費記錄失敗",
    l90: "缺少門店編號",
    l91: "門店密鑰為空",
    l92: "門店密鑰解析失敗",
    l93: "當前瀏覽器不支持 AES 解密",
    l94: "門店未開通",
    l95: "請輸入用戶名稱",
    l96: "支付鏈接生成失敗",
    l97: "已達到最大可選數量",
    l98: "選項",
    l99: "參數錯誤",
    l100: "必填",
    l101: "優惠券",
    l102: "登入後可用",
    l103: "已選",
    l104: "張",
    l105: "可用",
    l106: "0張可用",
    l107: "不可用",
    l108: "當前訂單可用",
    l109: "訂單滿",
    l110: "可用",
    l111: "自取",
    l112: "外賣",
    l113: "姓名",
    l114: "電話",
    l115: "郵編",
    l116: "地址",
    l117: "取餐時間",
    l118: "送達時間",
    l119: "選項必選",
    l120: "固定套餐",
    l121: "可選套餐選項",
    l122: "小費",
    l123: "菜品價格",
    l124: "服務費",
    l125: "打包費",
    l126: "份起",
    l127: "全部",
    l128: "含稅",
    l129: "稅前",
    l130: "請輸入",
    l131: "自定義備註",
    l132: "請輸入備註",
    l133: "備註",
    l134: "全選",
    l135: "合計",
    l136: "下單",
    l137: "獲得成功->",
    l138: "解析好的",
    l139: "本頁面僅顯示您掃碼下單的商品。如需查看完整賬單，請返回並點擊右下角圖標",
  },
  {
    l1: "Order",
    l2: "Restaurant Phone",
    l3: "Business Hours",
    l4: "Language",
    l5: "Table No.",
    l6: "Search",
    l7: "Back",
    l8: "Unit",
    l9: "Set Meal",
    l10: "Preparation",
    l11: "Add to Cart",
    l12: "OK",
    l13: "Method",
    l14: "Extra Price",
    l15: "Confirm",
    l16: "Cancel",
    l17: "Tips",
    l18: "Cart",
    l19: "Select All",
    l20: "Order",
    l21: "Delete?",
    l22: "No Food",
    l23: "Dining Time",
    l24: "Max",
    l25: "Confirm order?",
    l26: "Please select dishes first",
    l27: "Too many dishes",
    l28: "Ordering...",
    l29: "Order failed",
    l30: "Waiting for restaurant",
    l31: "Restaurant not accepted",
    l32: "Table not opened",
    l33: "Table is checking out",
    l34: "Exceeded max order count",
    l35: "Order quantity exceeded",
    l36: "Outside ordering hours",
    l37: "Order time expired, reopen table",
    l38: "Sold out",
    l39: "Restaurant not accepted",
    l40: "Preparation",
    l41: "Must select",
    l42: "Min select",
    l43: "Max select",
    l44: "Please select",
    l45: "Member Login",
    l46: "Login",
    l47: "Register",
    l48: "Please enter name",
    l49: "Get verification code",
    l50: "Please enter email",
    l51: "Please enter password",
    l52: "Log out current member?",
    l53: "Please enter valid email",
    l54: "Please enter verification code",
    l55: "Registration successful",
    l56: "Verification code sent",
    l57: "Failed to send code",
    l58: "Email already registered",
    l59: "Verification code error",
    l60: "Registration failed",
    l61: "Member not found or wrong password",
    l62: "No available coupons",
    l63: "Please login member first",
    l64: "Clear",
    l65: "Select coupon",
    l66: "Max select",
    l67: "Coupon",
    l68: "Coupon discount",
    l69: "Done",
    l70: "Email",
    l71: "Password",
    l72: "Enter your name",
    l73: "Enter email address",
    l74: "Enter verification code",
    l75: "Enter password",
    l76: "Selected",
    l77: "Select",
    l78: "Added successfully",
    l79: "No coupons available",
    l80: "Some coupons expired and have been removed",
    l81: "Max. selectable",
    l82: "coupon(s)",
    l83: "Order total does not meet coupon requirement",
    l84: "Discount cannot exceed order total",
    l85: "Failed to get store key",
    l86: "Login successful",
    l87: "Login failed",
    l88: "Member consume order number missing",
    l89: "Member consume record failed",
    l90: "Store number missing",
    l91: "Store key is empty",
    l92: "Store key parse failed",
    l93: "AES decrypt not supported in current browser",
    l94: "Store not activated",
    l95: "Please enter your name",
    l96: "Payment link generation failed",
    l97: "Max. selectable quantity reached",
    l98: "Options",
    l99: "Parameter error",
    l100: "Required",
    l101: "Coupon",
    l102: "Available after login",
    l103: "Selected",
    l104: "item(s)",
    l105: "Available",
    l106: "0 item(s) available",
    l107: "Not available",
    l108: "Available for this order",
    l109: "Order over",
    l110: "Available",
    l111: "Self Pickup",
    l112: "Delivery",
    l113: "Name",
    l114: "Phone",
    l115: "Postcode",
    l116: "Address",
    l117: "Pickup Time",
    l118: "Arrival Time",
    l119: "Required selections",
    l120: "Fixed set meal",
    l121: "Optional set meal items",
    l122: "Tip",
    l123: "Dish Price",
    l124: "Service Fee",
    l125: "Packing Fee",
    l126: "pcs minimum",
    l127: "All",
    l128: "Tax included",
    l129: "Before tax",
    l130: "Please enter",
    l131: "Custom remarks",
    l132: "Please enter remarks",
    l133: "Remarks",
    l134: "Select All",
    l135: "Total",
    l136: "Order",
    l137: "Got success->",
    l138: "Parsed",
    l139: "To view your full bill, please go back and tap the icon at the bottom right.",
  },
  {
    l1: "اطعمة",
    l2: "هاتف المطعم",
    l3: "ساعات العمل",
    l4: "اختيار اللغة",
    l5: "رقم الطاولة",
    l6: "بحث",
    l7: "العودة",
    l8: "اختيار الوحدة",
    l9: "مجموعة الطعام",
    l10: "اختيار الطريقة",
    l11: "أضف إلى السلة",
    l12: "أجل",
    l13: "طريقة",
    l14: "سعر إضافي",
    l15: "تأكيد",
    l16: "إلغاء",
    l17: "تلميح",
    l18: "عربة التسوق",
    l19: "تحديد جميع",
    l20: "اطعمة",
    l21: "حذف؟",
    l22: "لا طعام",
    l23: "وقت الأكل",
    l24: "حد أقصى",
    l25: "تأكيد الطلب؟",
    l26: "يرجى تحديد الأطباق أولاً",
    l27: "عدد الأطباق كبير جداً",
    l28: "جارٍ الطلب...",
    l29: "فشل الطلب",
    l30: "في انتظار المطعم",
    l31: "المطعم لم يقبل",
    l32: "الطاولة لم تفتح",
    l33: "الطاولة في مرحلة الدفع",
    l34: "تجاوزت عدد الطلبات",
    l35: "كمية الطلب تجاوزت الحد",
    l36: "الوقت خارج نطاق الطلب",
    l37: "انتهى وقت الطلب، أعد فتح الطاولة",
    l38: "مكتمل",
    l39: "المطعم لم يقبل",
    l40: "اختيار الطريقة",
    l41: "يجب الاختيار",
    l42: "الحد الأدنى",
    l43: "الحد الأقصى",
    l44: "يرجى الاختيار",
    l45: "تسجيل دخول العضو",
    l46: "تسجيل الدخول",
    l47: "تسجيل",
    l48: "الرجاء إدخال الاسم",
    l49: "الحصول على رمز التحقق",
    l50: "الرجاء إدخال البريد الإلكتروني",
    l51: "الرجاء إدخال كلمة المرور",
    l52: "هل تريد تسجيل خروج العضو الحالي؟",
    l53: "الرجاء إدخال بريد إلكتروني صحيح",
    l54: "الرجاء إدخال رمز التحقق",
    l55: "تم التسجيل بنجاح",
    l56: "تم إرسال رمز التحقق",
    l57: "فشل إرسال رمز التحقق",
    l58: "هذا البريد مسجل بالفعل",
    l59: "خطأ في رمز التحقق",
    l60: "فشل التسجيل",
    l61: "العضو غير موجود أو كلمة المرور خطأ",
    l62: "لا توجد قسائم متاحة",
    l63: "الرجاء تسجيل دخول العضو أولاً",
    l64: "مسح",
    l65: "اختيار القسيمة",
    l66: "الحد الأقصى للاختيار",
    l67: "القسيمة",
    l68: "خصم القسيمة",
    l69: "إنجاز",
    l70: "البريد الإلكتروني",
    l71: "كلمة المرور",
    l72: "أدخل اسم المستخدم",
    l73: "أدخل البريد الإلكتروني",
    l74: "أدخل رمز التحقق",
    l75: "أدخل كلمة المرور",
    l76: "محدد",
    l77: "اختيار",
    l78: "تمت الإضافة بنجاح",
    l79: "لا توجد قسائم خصم متاحة حالياً",
    l80: "بعض القسائم انتهت صلاحيتها وتم إلغاؤها تلقائياً",
    l81: "الحد الأقصى القابل للاختيار",
    l82: "قسيمة",
    l83: "إجمالي مبلغ الطلب لا يفي بشرط استخدام القسيمة",
    l84: "مبلغ الخصم لا يمكن أن يتجاوز مبلغ الطلب",
    l85: "فشل الحصول على مفتاح المتجر",
    l86: "تم تسجيل الدخول بنجاح",
    l87: "فشل تسجيل الدخول",
    l88: "رقم فاتورة استهلاك العضو مفقود",
    l89: "فشل تسجيل استهلاك العضو",
    l90: "رقم المتجر مفقود",
    l91: "مفتاح المتجر فارغ",
    l92: "فشل تحليل مفتاح المتجر",
    l93: "المتصفح الحالي لا يدعم فك تشفير AES",
    l94: "المتجر غير مفعل",
    l95: "الرجاء إدخال اسم المستخدم",
    l96: "فشل إنشاء رابط الدفع",
    l97: "تم الوصول إلى الحد الأقصى للكمية القابلة للاختيار",
    l98: "الخيارات",
    l99: "خطأ في المعاملات",
    l100: "مطلوب",
    l101: "قسيمة خصم",
    l102: "متاح بعد تسجيل الدخول",
    l103: "محدد",
    l104: "قطعة",
    l105: "متاح",
    l106: "0 قطعة متاحة",
    l107: "غير متاح",
    l108: "متاح لهذا الطلب",
    l109: "مبلغ الطلب يصل إلى",
    l110: "متاح",
    l111: "الاستلام بنفسي",
    l112: "التوصيل للمنزل",
    l113: "الاسم الكامل",
    l114: "رقم الهاتف",
    l115: "الرمز البريدي",
    l116: "العنوان",
    l117: "وقت استلام الوجبة",
    l118: "وقت الوصول",
    l119: "خيارات إجبارية",
    l120: "وجبة ثابتة",
    l121: "عناصر الوجبة الاختيارية",
    l122: "البقشيش",
    l123: "سعر الطبق",
    l124: "رسوم الخدمة",
    l125: "رسوم التغليف",
    l126: "الحد الأدنى للقطع",
    l127: "الكل",
    l128: "شامل الضريبة",
    l129: "قبل الضريبة",
    l130: "الرجاء الإدخال",
    l131: "ملاحظات مخصصة",
    l132: "الرجاء إدخال الملاحظات",
    l133: "ملاحظات",
    l134: "تحديد الكل",
    l135: "المجموع",
    l136: "تقديم الطلب",
    l137: "تم الحصول بنجاح->",
    l138: "تم تحليله",
    l139: "تُعرض هذه الصفحة فقط الأطعمة المطلوبة عبر مسح رمز الاستجابة السريعة. لعرض الفاتورة كاملة، ارجع وانقر على الأيقونة في أسفل اليمين.",
  },
  {
    l1: "បញ្ជាទិញអាហារ",
    l2: "ទូរស័ព្ទភោជនីយដ្ឋាន",
    l3: "ម៉ោងបើកការ",
    l4: "ជ្រើសរើសភាសា",
    l5: "លេខតុ",
    l6: "ស្វែងរក",
    l7: "ត្រឡប់មកវិញ",
    l8: "ជ្រើសរើសឯកតា",
    l9: "អាហារប្រកបដោយ",
    l10: "ជ្រើសរើសវិធី",
    l11: "បន្ថែមទៅកាបូប",
    l12: "ដឹងហើយ",
    l13: "វិធី",
    l14: "តម្លៃបន្ថែម",
    l15: "បញ្ជាក់",
    l16: "បោះបង់",
    l17: "ព្រមាន",
    l18: "កាបូប",
    l19: "ជ្រើសរើសទាំងអស់",
    l20: "បញ្ជាទិញ",
    l21: "លុប?",
    l22: "គ្មានអាហារ",
    l23: "ម៉ោងញ៉ាំ",
    l24: "អតិបរមា",
    l25: "បញ្ជាក់ការបញ្ជាទិញ?",
    l26: "សូមជ្រើសរើសអាហារបន្ទាប់",
    l27: "អាហារច្រើនពេក",
    l28: "កំពុងបញ្ជាទិញ...",
    l29: "បញ្ជាទិញបរាជ័យ",
    l30: "រង់ចាំភោជនីយដ្ឋាន",
    l31: "ភោជនីយដ្ឋានមិនទទួល",
    l32: "តុមិនបើក",
    l33: "តុកំពុងការដាក់ប្រាក់",
    l34: "លើសពីចំនួនអាចបញ្ជាទិញ",
    l35: "ចំនួនអាហារលើស",
    l36: "ពេលវេលាមិនក្នុងជួរ",
    l37: "ពេលវេលាបញ្ជាទិញផុតសុត",
    l38: "បញ្ចប់",
    l39: "ភោជនីយដ្ឋានមិនទទួល",
    l40: "ជ្រើសរើសវិធី",
    l41: "ត្រូវជ្រើសរើស",
    l42: "យ៉ាងតិច",
    l43: "អតិបរមា",
    l44: "សូមជ្រើសរើស",
    l45: "ចូលគណនីសមាជិក",
    l46: "ចូល",
    l47: "ចុះឈ្មោះ",
    l48: "សូមបញ្ចូលឈ្មោះ",
    l49: "ទទួលលេខកូដផ្ទៀងផ្ទាត់",
    l50: "សូមបញ្ចូលអ៊ីមែល",
    l51: "សូមបញ្ចូលពាក្យសម្ងាត់",
    l52: "តើចាក់ចេញពីគណនីបច្ចុប្បន្នទេ?",
    l53: "សូមបញ្ចូលទម្រង់អ៊ីមែលត្រឹមត្រូវ",
    l54: "សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    l55: "ចុះឈ្មោះជោគជ័យ",
    l56: "បានផ្ញើលេខកូដ",
    l57: "មិនអាចផ្ញើលេខកូដបាន",
    l58: "អ៊ីមែលនេះបានចុះឈ្មោះរួចរាល់",
    l59: "លេខកូដមិនត្រឹមត្រូវ",
    l60: "ការចុះឈ្មោះបរាជ័យ",
    l61: "គណនីមិនមានឬពាក្យសម្ងាត់ខុស",
    l62: "មិនមានគូប៉ុន",
    l63: "សូមចូលជាសមាជិកមុន",
    l64: "សំអាត",
    l65: "ជ្រើសរើសគូប៉ុន",
    l66: "ច្រើនបំផុត",
    l67: "គូប៉ុន",
    l68: "បញ្ចុះតម្លៃ",
    l69: "បានបញ្ចប់",
    l70: "អ៊ីមែល",
    l71: "ពាក្យសម្ងាត់",
    l72: "បញ្ចូលឈ្មោះអ្នកប្រើប្រាស់",
    l73: "បញ្ចូលអាសយដ្ឋានអ៊ីមែល",
    l74: "បញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    l75: "បញ្ចូលពាក្យសម្ងាត់",
    l76: "បានជ្រើសរើស",
    l77: "ជ្រើសរើស",
    l78: "បន្ថែមដោយជោគជ័យ",
    l79: "នាពេលបច្ចុប្បន្នមិនមានគូប៉ុនដែលអាចប្រើបាន",
    l80: "គូប៉ុនខ្លះបានផុតកំណត់ ហើយត្រូវបានលុបចោលដោយស្វ័យប្រវត្តិ",
    l81: "អាចជ្រើសរើសបានច្រើនបំផុត",
    l82: "គូប៉ុន",
    l83: "ទឹកប្រាក់បញ្ជាទិញនៅមិនទាន់ឈានដល់លក្ខខណ្ឌប្រើប្រាស់គូប៉ុននេះ",
    l84: "ទឹកប្រាក់បញ្ចុះតម្លៃមិនអាចធំជាងទឹកប្រាក់បញ្ជាទិញបានទេ",
    l85: "ទទួលបានសោហាងបានបរាជ័យ",
    l86: "ចូលប្រើដោយជោគជ័យ",
    l87: "ចូលប្រើមិនបានជោគជ័យ",
    l88: "ខ្វះលេខប័ណ្ណប្រើប្រាស់សមាជិក",
    l89: "កត់ត្រាការប្រើប្រាស់សមាជិកបានបរាជ័យ",
    l90: "ខ្វះលេខសម្គាល់ហាង",
    l91: "សោហាងមានតម្លៃទទេ",
    l92: "បកស្រាយសោហាងបានបរាជ័យ",
    l93: "កម្មវិធីរុករកបច្ចុប្បន្នមិនគាំទ្រការដោះស្រាយ AES",
    l94: "ហាងមិនទាន់បានបើកដំណើរការ",
    l95: "សូមបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់",
    l96: "បង្កើតតំណផ្តល់ប្រាក់បានបរាជ័យ",
    l97: "បានឈានដល់ចំនួនអតិបរមាដែលអាចជ្រើសរើសបាន",
    l98: "ជម្រើស",
    l99: "កំហុសប៉ារ៉ាម៉ែត្រ",
    l100: "ចាំបាច់ត្រូវបញ្ចូល",
    l101: "គូប៉ុន",
    l102: "អាចប្រើបានបន្ទាប់ពីចូលប្រើ",
    l103: "បានជ្រើសរើស",
    l104: "បំណែក",
    l105: "អាចប្រើបាន",
    l106: "0 បំណែកអាចប្រើបាន",
    l107: "មិនអាចប្រើបាន",
    l108: "អាចប្រើសម្រាប់បញ្ជាទិញនេះ",
    l109: "បញ្ជាទិញមានចំនួនលើសពី",
    l110: "អាចប្រើបាន",
    l111: "មកយកដោយខ្លួនឯង",
    l112: "ដឹកជញ្ជូនមកកាន់",
    l113: "ឈ្មោះពេញ",
    l114: "លេខទូរស័ព្ទ",
    l115: "លេខកូដប្រៃសណីយ៍",
    l116: "អាសយដ្ឋាន",
    l117: "ម៉ោងយកអាហារ",
    l118: "ម៉ោងដល់កន្លែង",
    l119: "ជម្រើសចាំបាច់ត្រូវជ្រើស",
    l120: "មុខម្ហូបថេរ",
    l121: "ធាតុជម្រើសមុខម្ហូប",
    l122: "ប្រាក់រង្វាន់",
    l123: "តម្លៃមុខម្ហូប",
    l124: "ថ្លៃសេវា",
    l125: "ថ្លៃវេចខ្ចប់",
    l126: "ចំនួនអប្បបរមា",
    l127: "ទាំងអស់",
    l128: "រួមបញ្ចូលពន្ធរួចរាល់",
    l129: "មិនទាន់បញ្ចូលពន្ធ",
    l130: "សូមបញ្ចូល",
    l131: "ការអធិប្បាយផ្ទាល់ខ្លួន",
    l132: "សូមបញ្ចូលការអធិប្បាយ",
    l133: "ការអធិប្បាយ",
    l134: "ជ្រើសរើសទាំងអស់",
    l135: "សរុបចំនួនទឹកប្រាក់",
    l136: "ដាក់បញ្ជាទិញ",
    l137: "ទទួលបានជោគជ័យ->",
    l138: "បានបកស្រាយរួចរាល់",
    l139: "ទំព័រនេះបង្ហាញតែមុខម្ហូបដែលបញ្ជាដោយស្គែនកូដ QR ប៉ុណ្ណោះ។ ដើម្បីមើលវិក្កយបត្រពេញលេញ សូមត្រឡប់ទៅវិញ ហើយចុចលើរូបតំណាងនៅជ្រុងខាងក្រោមស្តាំ។",
  },
  {
    l1: "Ordenar",
    l2: "Teléfono del restaurante",
    l3: "Horario",
    l4: "Idioma",
    l5: "Número de mesa",
    l6: "Buscar",
    l7: "Volver",
    l8: "Unidad",
    l9: "Menú combinado",
    l10: "Preparación",
    l11: "Añadir al carrito",
    l12: "OK",
    l13: "Método",
    l14: "Precio extra",
    l15: "Confirmar",
    l16: "Cancelar",
    l17: "Consejos",
    l18: "Carrito",
    l19: "Seleccionar todo",
    l20: "Ordenar",
    l21: "Eliminar?",
    l22: "Sin comida",
    l23: "Hora de comida",
    l24: "Máximo",
    l25: "¿Confirmar pedido?",
    l26: "Seleccione platos primero",
    l27: "Demasiados platos",
    l28: "Procesando...",
    l29: "Pedido fallido",
    l30: "Esperando restaurante",
    l31: "Restaurante no aceptó",
    l32: "Mesa no abierta",
    l33: "Mesa en proceso de pago",
    l34: "Superó el límite de pedidos",
    l35: "Cantidad excedida",
    l36: "Fuera de horario de pedido",
    l37: "Tiempo de pedido expirado",
    l38: "Agotado",
    l39: "Restaurante no aceptó",
    l40: "Preparación",
    l41: "Debe seleccionar",
    l42: "Min seleccionar",
    l43: "Max seleccionar",
    l44: "Seleccione",
    l45: "Inicio de sesión de socio",
    l46: "Iniciar sesión",
    l47: "Registrarse",
    l48: "Por favor ingrese nombre",
    l49: "Obtener código de verificación",
    l50: "Por favor ingrese correo",
    l51: "Por favor ingrese contraseña",
    l52: "¿Cerrar sesión del socio actual?",
    l53: "Por favor ingrese correo válido",
    l54: "Por favor ingrese código",
    l55: "Registro exitoso",
    l56: "Código enviado",
    l57: "Error al enviar código",
    l58: "Correo ya registrado",
    l59: "Error de código de verificación",
    l60: "Registro fallido",
    l61: "Socio no existe o contraseña errónea",
    l62: "Sin cupones disponibles",
    l63: "Por favor inicie sesión primero",
    l64: "Vaciar",
    l65: "Seleccionar cupón",
    l66: "Máx seleccionar",
    l67: "Cupón",
    l68: "Descuento de cupón",
    l69: "Terminado",
    l70: "Correo electrónico",
    l71: "Contraseña",
    l72: "Introduzca el nombre de usuario",
    l73: "Introduzca el correo electrónico",
    l74: "Introduzca el código de verificación",
    l75: "Introduzca la contraseña",
    l76: "Seleccionado",
    l77: "Seleccionar",
    l78: "Añadido correctamente",
    l79: "No hay cupones disponibles en este momento",
    l80: "Algunos cupones han caducado y se han eliminado automáticamente",
    l81: "Seleccionable como máximo",
    l82: "cupón(es)",
    l83: "El importe total del pedido no cumple con el requisito del cupón",
    l84: "El importe de descuento no puede ser mayor que el total del pedido",
    l85: "No se pudo obtener la clave de la tienda",
    l86: "Inicio de sesión correcto",
    l87: "Error al iniciar sesión",
    l88: "Falta el número de factura de consumo del miembro",
    l89: "Error en el registro de consumo del miembro",
    l90: "Falta el número de tienda",
    l91: "La clave de la tienda está vacía",
    l92: "No se pudo analizar la clave de la tienda",
    l93: "Este navegador no es compatible con el descifrado AES",
    l94: "Tienda no activada",
    l95: "Por favor introduzca el nombre de usuario",
    l96: "No se pudo generar el enlace de pago",
    l97: "Se ha alcanzado la cantidad máxima seleccionable",
    l98: "Opciones",
    l99: "Error de parámetros",
    l100: "Obligatorio",
    l101: "Cupón de descuento",
    l102: "Disponible tras iniciar sesión",
    l103: "Seleccionado",
    l104: "artículo(s)",
    l105: "Disponible",
    l106: "0 artículos disponibles",
    l107: "No disponible",
    l108: "Disponible para este pedido",
    l109: "Pedido con importe superior a",
    l110: "Disponible",
    l111: "Recogida personal",
    l112: "Entrega a domicilio",
    l113: "Nombre completo",
    l114: "Número de teléfono",
    l115: "Código postal",
    l116: "Dirección",
    l117: "Hora de recogida",
    l118: "Hora de llegada",
    l119: "Opciones obligatorias",
    l120: "Menú fijo",
    l121: "Artículos opcionales del menú",
    l122: "Propina",
    l123: "Precio del plato",
    l124: "Gastos de servicio",
    l125: "Gastos de embalaje",
    l126: "unidades mínimas",
    l127: "Todo",
    l128: "Impuestos incluidos",
    l129: "Antes de impuestos",
    l130: "Por favor introduzca",
    l131: "Notas personalizadas",
    l132: "Introduzca las notas",
    l133: "Notas",
    l134: "Seleccionar todo",
    l135: "Importe total",
    l136: "Realizar pedido",
    l137: "Obtenido con éxito->",
    l138: "Analizado",
    l139: "Esta página solo muestra los artículos pedidos mediante código QR. Para ver la factura completa, regrese y haga clic en el icono de la parte inferior derecha.",
  },
  {
    l1: "Нарачун",
    l2: "Телефон ресторана",
    l3: "Радно време",
    l4: "Језик",
    l5: "Број столице",
    l6: "Претрага",
    l7: "Назад",
    l8: "Јединица",
    l9: "Комбиновани оброк",
    l10: "Припрема",
    l11: "Додати у кошић",
    l12: "У rédu",
    l13: "Метод",
    l14: "Додатна цена",
    l15: "Потврдити",
    l16: "Откаzeti",
    l17: "Напомена",
    l18: "Кошића",
    l19: "Изабери све",
    l20: "Нарачити",
    l21: "Обрисати?",
    l22: "Нема хране",
    l23: "Време јели",
    l24: "Максимално",
    l25: "Потврдити нарачун?",
    l26: "Изаберите јело прво",
    l27: "Превише јела",
    l28: "Обрађује се...",
    l29: "Нарачун неуспешан",
    l30: "Чекање на ресторан",
    l31: "Ресторан није прихватио",
    l32: "Столица није отворена",
    l33: "Столица у процесу плаћања",
    l34: "Превише нарачуна",
    l35: "Количина превазила",
    l36: "Изван времена нарачуна",
    l37: "Време нарачуна истекло",
    l38: "Испразно",
    l39: "Ресторан није прихватио",
    l40: "Припрема",
    l41: "Мора изабрати",
    l42: "Минимално",
    l43: "Максимално",
    l44: "Изаберите",
    l45: "Пријава члана",
    l46: "Пријава",
    l47: "Регистрација",
    l48: "Унесите име",
    l49: "Добити код за верификацију",
    l50: "Унесите имејл",
    l51: "Унесите лозинку",
    l52: "Одјавити тренутног члана?",
    l53: "Унесите исправан имејл",
    l54: "Унесите код за верификацију",
    l55: "Регистрација успешна",
    l56: "Код послат",
    l57: "Сланје кода није успело",
    l58: "Имејл је већ регистрован",
    l59: "Погрешан код за верификацију",
    l60: "Регистрација није успела",
    l61: "Члан не постоји или погрешна лозинка",
    l62: "Нема доступних купона",
    l63: "Прво се пријавите као члан",
    l64: "Обрисати",
    l65: "Изабери купон",
    l66: "Максимално",
    l67: "Купон",
    l68: "Попист",
    l69: "Завршено",
    l70: "Е‑маил",
    l71: "Лозинка",
    l72: "Унесите корисничко име",
    l73: "Унесите адресу е‑маил",
    l74: "Унесите верификациони код",
    l75: "Унесите лозинку",
    l76: "Изабрано",
    l77: "Изабери",
    l78: "Успешно додато",
    l79: "Тренутно нема доступних купона",
    l80: "Неки купони су истекли и аутоматски су уклоњени",
    l81: "Максимално за избор",
    l82: "купон(а)",
    l83: "Укупна вредност поруџбине не испуњава услов купона",
    l84: "Попуст не може бити већи од укупне вредности поруџбине",
    l85: "Није успело добављање кључа продавнице",
    l86: "Успешно пријављивање",
    l87: "Неуспело пријављивање",
    l88: "Недостаје број потрошњачког налога члана",
    l89: "Неуспела евиденција потрошње члана",
    l90: "Недостаје број продавнице",
    l91: "Кључ продавнице је празан",
    l92: "Није успела анализа кључа продавнице",
    l93: "Овај прегледач не подржава AES дешифровање",
    l94: "Продавница није активирана",
    l95: "Унесите корисничко име",
    l96: "Није успело генерисање линка за плаћање",
    l97: "Достигнут је максимални број комада за избор",
    l98: "Опције",
    l99: "Грешка у параметрима",
    l100: "Обавезно",
    l101: "Купон за попуст",
    l102: "Доступно након пријављивања",
    l103: "Изабрано",
    l104: "ставка(и)",
    l105: "Доступно",
    l106: "0 ставки доступно",
    l107: "Недоступно",
    l108: "Доступно за ову поруџбину",
    l109: "Поруџбина изнад износа",
    l110: "Доступно",
    l111: "Лично преузимање",
    l112: "Доставка",
    l113: "Име и презиме",
    l114: "Телефон",
    l115: "Поштански број",
    l116: "Адреса",
    l117: "Време преузимања",
    l118: "Време доласка",
    l119: "Обавезне опције",
    l120: "Фиксни мени",
    l121: "Опциони ставке менија",
    l122: "Бакшиш",
    l123: "Цена јела",
    l124: "Услужна накнада",
    l125: "Накнада за паковање",
    l126: "комад минимум",
    l127: "Све",
    l128: "Са пореском",
    l129: "Пре пореза",
    l130: "Унесите",
    l131: "Произвољне напомене",
    l132: "Унесите напомене",
    l133: "Напомене",
    l134: "Изабери све",
    l135: "Укупан износ",
    l136: "Поруџбина",
    l137: "Успешно добављено->",
    l138: "Анализирано",
    l139: "Ова страница приказује само ставке наручене скенирањем QR кода. За комплетан рачун вратите се и кликните на икону у доњем десном углу.",
  },
  {
    l1: "Bestellen",
    l2: "Restaurant telefoon",
    l3: "Openingstijden",
    l4: "Taal",
    l5: "Tafelnummer",
    l6: "Zoeken",
    l7: "Terug",
    l8: "Eenheid",
    l9: "Menu",
    l10: "Bereiding",
    l11: "Toevoegen aan winkelwagen",
    l12: "OK",
    l13: "Methode",
    l14: "Extra prijs",
    l15: "Bevestigen",
    l16: "Annuleren",
    l17: "Tips",
    l18: "Winkelwagen",
    l19: "Selecteer alles",
    l20: "Bestellen",
    l21: "Verwijderen?",
    l22: "Geen eten",
    l23: "Eet tijd",
    l24: "Max",
    l25: "Bevestig bestelling?",
    l26: "Selecteer gerechten eerst",
    l27: "Te veel gerechten",
    l28: "Bezig...",
    l29: "Bestelling mislukt",
    l30: "Wachten op restaurant",
    l31: "Restaurant niet geaccepteerd",
    l32: "Tafel niet geopend",
    l33: "Tafel in afrekening",
    l34: "Maximum bestellingen overschreden",
    l35: "Aantal overschreden",
    l36: "Buiten besteluren",
    l37: "Besteltijd verlopen",
    l38: "Uitverkocht",
    l39: "Restaurant niet geaccepteerd",
    l40: "Bereiding",
    l41: "Moet selecteren",
    l42: "Min selecteren",
    l43: "Max selecteren",
    l44: "Selecteer",
    l45: "Lid aanmelden",
    l46: "Aanmelden",
    l47: "Registreren",
    l48: "Voer naam in",
    l49: "Verificatiecode ophalen",
    l50: "Voer e-mail in",
    l51: "Voer wachtwoord in",
    l52: "Huidig lid afmelden?",
    l53: "Voer geldig e-mailadres in",
    l54: "Voer verificatiecode in",
    l55: "Registratie gelukt",
    l56: "Code verzonden",
    l57: "Code verzenden mislukt",
    l58: "E-mail al geregistreerd",
    l59: "Verificatiefout",
    l60: "Registratie mislukt",
    l61: "Lid niet gevonden of wachtwoord onjuist",
    l62: "Geen coupons beschikbaar",
    l63: "Meld u eerst aan als lid",
    l64: "Wissen",
    l65: "Coupon selecteren",
    l66: "Max selecteren",
    l67: "Coupon",
    l68: "Couponkorting",
    l69: "Voltooid",
    l70: "E‑mail",
    l71: "Wachtwoord",
    l72: "Voer gebruikersnaam in",
    l73: "Voer het e‑mailadres in",
    l74: "Voer de verificatiecode in",
    l75: "Voer het wachtwoord in",
    l76: "Geselecteerd",
    l77: "Selecteren",
    l78: "Succesvol toegevoegd",
    l79: "Er zijn momenteel geen kortingsbonnen beschikbaar",
    l80: "Sommige kortingsbonnen zijn verlopen en automatisch verwijderd",
    l81: "Maximaal selecteerbaar",
    l82: "kortingsbon(nen)",
    l83: "Het totaalbedrag van de bestelling voldoet niet aan de voorwaarde van de kortingsbon",
    l84: "Het kortingsbedrag mag niet hoger zijn dan het totaalbedrag van de bestelling",
    l85: "Ophalen van de winkelsleutel mislukt",
    l86: "Succesvol ingelogd",
    l87: "Inloggen mislukt",
    l88: "Nummer van het ledenverbruik ontbreekt",
    l89: "Ledenverbruiksregistratie mislukt",
    l90: "Winkelnummer ontbreekt",
    l91: "De winkelsleutel is leeg",
    l92: "Analyse van de winkelsleutel mislukt",
    l93: "Deze browser ondersteunt geen AES‑ontsleuteling",
    l94: "Winkel niet geactiveerd",
    l95: "Voer gebruikersnaam in",
    l96: "Betalingslink genereren mislukt",
    l97: "Maximaal aantal selecteerbare stuks bereikt",
    l98: "Opties",
    l99: "Parameterfout",
    l100: "Verplicht",
    l101: "Kortingsbon",
    l102: "Beschikbaar na inloggen",
    l103: "Geselecteerd",
    l104: "stuk(s)",
    l105: "Beschikbaar",
    l106: "0 stuks beschikbaar",
    l107: "Niet beschikbaar",
    l108: "Beschikbaar voor deze bestelling",
    l109: "Bestelling met een bedrag vanaf",
    l110: "Beschikbaar",
    l111: "Zelf afhalen",
    l112: "Bezorging aan huis",
    l113: "Volledige naam",
    l114: "Telefoonnummer",
    l115: "Postcode",
    l116: "Adres",
    l117: "Afhaaltijd",
    l118: "Aankomsttijd",
    l119: "Verplichte keuzes",
    l120: "Vast menu",
    l121: "Optionele menu‑items",
    l122: "Fooien",
    l123: "Prijs van het gerecht",
    l124: "Servicekosten",
    l125: "Verpakkingskosten",
    l126: "stuks minimum",
    l127: "Alles",
    l128: "Inclusief btw",
    l129: "Vóór btw",
    l130: "Voer in",
    l131: "Aangepaste opmerkingen",
    l132: "Voer opmerkingen in",
    l133: "Opmerkingen",
    l134: "Alles selecteren",
    l135: "Totaalbedrag",
    l136: "Bestelling plaatsen",
    l137: "Succesvol opgehaald->",
    l138: "Geanalyseerd",
    l139: "Dit overzicht toont alleen de bestellingen via de QR-code. Ga terug en tik op het icoon rechtsonder voor de volledige rekening.",
  },
  {
    l1: "Commander",
    l2: "Téléphone du restaurant",
    l3: "Horaires",
    l4: "Langue",
    l5: "Numéro de table",
    l6: "Rechercher",
    l7: "Retour",
    l8: "Unité",
    l9: "Menu",
    l10: "Préparation",
    l11: "Ajouter au panier",
    l12: "OK",
    l13: "Méthode",
    l14: "Prix supplémentaire",
    l15: "Confirmer",
    l16: "Annuler",
    l17: "Conseils",
    l18: "Panier",
    l19: "Sélectionner tout",
    l20: "Commander",
    l21: "Supprimer?",
    l22: "Pas de nourriture",
    l23: "Heure de repas",
    l24: "Max",
    l25: "Confirmer la commande?",
    l26: "Sélectionnez les plats d'abord",
    l27: "Trop de plats",
    l28: "En cours...",
    l29: "Commande échouée",
    l30: "Attente restaurant",
    l31: "Restaurant non accepté",
    l32: "Table non ouverte",
    l33: "Table encaissement",
    l34: "Limite de commandes dépassée",
    l35: "Quantité dépassée",
    l36: "Hors heures de commande",
    l37: "Temps de commande expiré",
    l38: "Épuisé",
    l39: "Restaurant non accepté",
    l40: "Préparation",
    l41: "Doit sélectionner",
    l42: "Min sélectionner",
    l43: "Max sélectionner",
    l44: "Sélectionnez",
    l45: "Connexion membre",
    l46: "Connexion",
    l47: "Inscription",
    l48: "Veuillez saisir le nom",
    l49: "Obtenir le code de vérification",
    l50: "Veuillez saisir l'e-mail",
    l51: "Veuillez saisir le mot de passe",
    l52: "Déconnecter le membre actuel ?",
    l53: "Veuillez saisir un e-mail valide",
    l54: "Veuillez saisir le code de vérification",
    l55: "Inscription réussie",
    l56: "Code envoyé",
    l57: "Échec de l'envoi du code",
    l58: "E-mail déjà enregistré",
    l59: "Erreur de code de vérification",
    l60: "Échec de l'inscription",
    l61: "Membre introuvable ou mot de passe erroné",
    l62: "Aucun coupon disponible",
    l63: "Veuillez vous connecter d'abord",
    l64: "Effacer",
    l65: "Choisir un coupon",
    l66: "Sélection max",
    l67: "Coupon",
    l68: "Réduction coupon",
    l69: "Terminé",
    l70: "Courrier électronique",
    l71: "Mot de passe",
    l72: "Saisissez le nom d’utilisateur",
    l73: "Saisissez l’adresse de courrier électronique",
    l74: "Saisissez le code de vérification",
    l75: "Saisissez le mot de passe",
    l76: "Sélectionné",
    l77: "Sélectionner",
    l78: "Ajouté avec succès",
    l79: "Aucun bon de réduction disponible pour le moment",
    l80: "Certains bons de réduction ont expiré et ont été retirés automatiquement",
    l81: "Sélectionnable au maximum",
    l82: "bon(s) de réduction",
    l83: "Le montant total de la commande ne remplit pas la condition du bon de réduction",
    l84: "Le montant de la remise ne peut pas être supérieur au total de la commande",
    l85: "Échec de récupération de la clé du magasin",
    l86: "Connexion réussie",
    l87: "Échec de la connexion",
    l88: "Numéro de facture de consommation membre manquant",
    l89: "Échec de l’enregistrement de la consommation membre",
    l90: "Numéro de magasin manquant",
    l91: "La clé du magasin est vide",
    l92: "Échec de l’analyse de la clé du magasin",
    l93: "Ce navigateur ne prend pas en charge le déchiffrement AES",
    l94: "Magasin non activé",
    l95: "Veuillez saisir le nom d’utilisateur",
    l96: "Échec de la génération du lien de paiement",
    l97: "Quantité maximale sélectionnable atteinte",
    l98: "Options",
    l99: "Erreur de paramètre",
    l100: "Obligatoire",
    l101: "Bon de réduction",
    l102: "Disponible après connexion",
    l103: "Sélectionné",
    l104: "article(s)",
    l105: "Disponible",
    l106: "0 article disponible",
    l107: "Indisponible",
    l108: "Disponible pour cette commande",
    l109: "Commande d’un montant supérieur à",
    l110: "Disponible",
    l111: "Retrait sur place",
    l112: "Livraison à domicile",
    l113: "Nom complet",
    l114: "Numéro de téléphone",
    l115: "Code postal",
    l116: "Adresse",
    l117: "Heure de retrait",
    l118: "Heure d’arrivée",
    l119: "Sélections obligatoires",
    l120: "Menu fixe",
    l121: "Articles du menu optionnels",
    l122: "Pourboire",
    l123: "Prix du plat",
    l124: "Frais de service",
    l125: "Frais d’emballage",
    l126: "pièce(s) minimum",
    l127: "Tout",
    l128: "TTC",
    l129: "HT",
    l130: "Veuillez saisir",
    l131: "Remarques personnalisées",
    l132: "Veuillez saisir les remarques",
    l133: "Remarques",
    l134: "Tout sélectionner",
    l135: "Montant total",
    l136: "Passer la commande",
    l137: "Récupéré avec succès->",
    l138: "Analysé",
    l139: "Cette page affiche uniquement les plats commandés via le code QR. Pour voir la facture complète, revenez en arrière et cliquez sur l’icône en bas à droite.",
  },
  {
    l1: "Ordinare",
    l2: "Telefono ristorante",
    l3: "Orari",
    l4: "Lingua",
    l5: "Numero tavolo",
    l6: "Cerca",
    l7: "Indietro",
    l8: "Unità",
    l9: "Menu",
    l10: "Preparazione",
    l11: "Aggiungi al carrello",
    l12: "OK",
    l13: "Metodo",
    l14: "Prezzo extra",
    l15: "Conferma",
    l16: "Annulla",
    l17: "Consigli",
    l18: "Carrello",
    l19: "Seleziona tutto",
    l20: "Ordina",
    l21: "Eliminare?",
    l22: "Nessun cibo",
    l23: "Ora di mangiare",
    l24: "Massimo",
    l25: "Confermare ordine?",
    l26: "Seleziona piatti prima",
    l27: "Troppi piatti",
    l28: "In corso...",
    l29: "Ordine fallito",
    l30: "Attendere ristorante",
    l31: "Ristorante non accettato",
    l32: "Tavolo non aperto",
    l33: "Tavolo in pagamento",
    l34: "Limite ordini superata",
    l35: "Quantità superata",
    l36: "Fuori orari ordine",
    l37: "Tempo ordine scaduto",
    l38: "Terminato",
    l39: "Ristorante non accettato",
    l40: "Preparazione",
    l41: "Deve selezionare",
    l42: "Min selezionare",
    l43: "Max selezionare",
    l44: "Seleziona",
    l45: "Accesso membro",
    l46: "Accedi",
    l47: "Registrati",
    l48: "Inserisci il nome",
    l49: "Ottieni codice di verifica",
    l50: "Inserisci email",
    l51: "Inserisci password",
    l52: "Disconnettere il membro corrente?",
    l53: "Inserisci email valida",
    l54: "Inserisci codice di verifica",
    l55: "Registrazione riuscita",
    l56: "Codice inviato",
    l57: "Invio codice fallito",
    l58: "Email già registrata",
    l59: "Errore codice verifica",
    l60: "Registrazione fallita",
    l61: "Membro inesistente o password errata",
    l62: "Nessun coupon disponibile",
    l63: "Accedi prima come membro",
    l64: "Svuota",
    l65: "Seleziona coupon",
    l66: "Max selezione",
    l67: "Coupon",
    l68: "Sconto coupon",
    l69: "Completato",
    l70: "Posta elettronica",
    l71: "Parola d'ordine",
    l72: "Inserisci il nome utente",
    l73: "Inserisci l’indirizzo di posta elettronica",
    l74: "Inserisci il codice di verifica",
    l75: "Inserisci la parola d'ordine",
    l76: "Selezionato",
    l77: "Seleziona",
    l78: "Aggiunto correttamente",
    l79: "Nessun buono sconto disponibile al momento",
    l80: "Alcuni buoni sconto sono scaduti e sono stati rimossi automaticamente",
    l81: "Selezionabile al massimo",
    l82: "buono/i sconto",
    l83: "Il totale dell’ordine non soddisfa il requisito del buono sconto",
    l84: "L’importo dello sconto non può superare il totale dell’ordine",
    l85: "Recupero chiave negozio non riuscito",
    l86: "Accesso effettuato",
    l87: "Accesso non riuscito",
    l88: "Numero fattura consumo membro mancante",
    l89: "Registrazione consumo membro non riuscita",
    l90: "Numero negozio mancante",
    l91: "La chiave negozio è vuota",
    l92: "Analisi chiave negozio non riuscita",
    l93: "Questo browser non supporta la decifratura AES",
    l94: "Negozio non attivato",
    l95: "Inserisci il nome utente",
    l96: "Generazione link pagamento non riuscita",
    l97: "Quantità massima selezionabile raggiunta",
    l98: "Opzioni",
    l99: "Errore parametro",
    l100: "Obbligatorio",
    l101: "Buono sconto",
    l102: "Disponibile dopo l’accesso",
    l103: "Selezionato",
    l104: "articolo/i",
    l105: "Disponibile",
    l106: "0 articoli disponibili",
    l107: "Non disponibile",
    l108: "Disponibile per questo ordine",
    l109: "Ordine con importo superiore a",
    l110: "Disponibile",
    l111: "Ritiro personale",
    l112: "Consegna a domicilio",
    l113: "Nome completo",
    l114: "Numero di telefono",
    l115: "Codice postale",
    l116: "Indirizzo",
    l117: "Ora di ritiro",
    l118: "Ora di arrivo",
    l119: "Scelte obbligatorie",
    l120: "Menu fisso",
    l121: "Articoli del menu opzionali",
    l122: "Mancia",
    l123: "Prezzo del piatto",
    l124: "Costo del servizio",
    l125: "Costo dell’imballaggio",
    l126: "pezzo/i minimo",
    l127: "Tutto",
    l128: "Iva inclusa",
    l129: "Prima dell’Iva",
    l130: "Inserisci",
    l131: "Note personalizzate",
    l132: "Inserisci le note",
    l133: "Note",
    l134: "Seleziona tutto",
    l135: "Importo totale",
    l136: "Invia ordine",
    l137: "Recuperato con successo->",
    l138: "Analizzato",
    l139: "Questa pagina mostra solo i piatti ordinati tramite codice QR. Per visualizzare il conto completo, torna indietro e clicca sull’icona in basso a destra.",
  },
  {
    l1: "注文",
    l2: "レストラン電話",
    l3: "営業時間",
    l4: "言語",
    l5: "テーブル番号",
    l6: "検索",
    l7: "戻る",
    l8: "単位",
    l9: "セットメニュー",
    l10: "調理方法",
    l11: "カートに追加",
    l12: "OK",
    l13: "方法",
    l14: "追加料金",
    l15: "確認",
    l16: "キャンセル",
    l17: "ヒント",
    l18: "カート",
    l19: "全選択",
    l20: "注文",
    l21: "削除？",
    l22: "食べ物なし",
    l23: "食事時間",
    l24: "最大",
    l25: "注文を確定しますか？",
    l26: "料理を選択してください",
    l27: "料理が多すぎます",
    l28: "注文中...",
    l29: "注文失敗",
    l30: "レストラン待ち",
    l31: "レストラン未受付",
    l32: "テーブル未開台",
    l33: "テーブル精算中",
    l34: "注文回数超過",
    l35: "注文数量超過",
    l36: "注文時間外",
    l37: "注文時間切れ",
    l38: "完売",
    l39: "レストラン未受付",
    l40: "調理方法",
    l41: "必ず選択",
    l42: "最少選択",
    l43: "最多選択",
    l44: "選択してください",
    l45: "会員ログイン",
    l46: "ログイン",
    l47: "登録",
    l48: "名前を入力してください",
    l49: "認証コード取得",
    l50: "メールアドレスを入力してください",
    l51: "パスワードを入力してください",
    l52: "現在の会員をログアウトしますか？",
    l53: "正しいメール形式を入力してください",
    l54: "認証コードを入力してください",
    l55: "登録成功",
    l56: "認証コード送信済",
    l57: "認証コード送信失敗",
    l58: "このメールは既に登録されています",
    l59: "認証コードエラー",
    l60: "登録失敗",
    l61: "会員が存在しないかパスワードエラー",
    l62: "利用可能なクーポンがありません",
    l63: "先に会員ログインしてください",
    l64: "クリア",
    l65: "クーポン選択",
    l66: "最大選択",
    l67: "クーポン",
    l68: "クーポン割引",
    l69: "完了",
    l70: "メールアドレス",
    l71: "パスワード",
    l72: "ユーザー名を入力してください",
    l73: "メールアドレスを入力してください",
    l74: "認証コードを入力してください",
    l75: "パスワードを入力してください",
    l76: "選択済み",
    l77: "選択する",
    l78: "追加に成功しました",
    l79: "現在利用可能なクーポンはありません",
    l80: "一部のクーポンは有効期限が切れて自動的に削除されました",
    l81: "最大選択可能数",
    l82: "枚のクーポン",
    l83: "注文金額がクーポンの利用条件に達していません",
    l84: "割引金額は注文金額を超えることはできません",
    l85: "店舗キーの取得に失敗しました",
    l86: "ログインに成功しました",
    l87: "ログインに失敗しました",
    l88: "会員消費注文番号が不足しています",
    l89: "会員消費記録の登録に失敗しました",
    l90: "店舗番号が不足しています",
    l91: "店舗キーが空です",
    l92: "店舗キーの解析に失敗しました",
    l93: "このブラウザは AES 復号に対応していません",
    l94: "店舗はまだ開設されていません",
    l95: "ユーザー名を入力してください",
    l96: "決済リンクの生成に失敗しました",
    l97: "選択可能な最大数量に達しました",
    l98: "オプション",
    l99: "パラメータエラー",
    l100: "必須項目",
    l101: "割引クーポン",
    l102: "ログイン後に利用可能",
    l103: "選択済み",
    l104: "枚",
    l105: "利用可能",
    l106: "0 枚利用可能",
    l107: "利用不可",
    l108: "この注文で利用可能",
    l109: "注文金額が",
    l110: "利用可能",
    l111: "店頭受け取り",
    l112: "配達",
    l113: "氏名",
    l114: "電話番号",
    l115: "郵便番号",
    l116: "住所",
    l117: "受け取り時間",
    l118: "到着時間",
    l119: "必須オプション",
    l120: "固定セットメニュー",
    l121: "オプションのセットメニュー項目",
    l122: "チップ",
    l123: "料理の価格",
    l124: "サービス料",
    l125: "テイクアウト料",
    l126: "個以上から",
    l127: "すべて",
    l128: "税込み",
    l129: "税別",
    l130: "入力してください",
    l131: "カスタム備考",
    l132: "備考を入力してください",
    l133: "備考",
    l134: "すべて選択",
    l135: "合計金額",
    l136: "注文する",
    l137: "取得に成功しました->",
    l138: "解析済み",
    l139: "このページにはQRコードで注文した料理のみ表示されます。完全な請求書を見るには、戻って右下のアイコンをタップしてください。",
  },
  {
    l1: "Pedir",
    l2: "Telefone do restaurante",
    l3: "Horário",
    l4: "Idioma",
    l5: "Número da mesa",
    l6: "Pesquisar",
    l7: "Voltar",
    l8: "Unidade",
    l9: "Menu",
    l10: "Preparo",
    l11: "Adicionar ao carrinho",
    l12: "OK",
    l13: "Método",
    l14: "Preço extra",
    l15: "Confirmar",
    l16: "Cancelar",
    l17: "Dicas",
    l18: "Carrinho",
    l19: "Selecionar tudo",
    l20: "Pedir",
    l21: "Excluir?",
    l22: "Sem comida",
    l23: "Hora da refeição",
    l24: "Máximo",
    l25: "Confirmar pedido?",
    l26: "Selecione pratos primeiro",
    l27: "Muitos pratos",
    l28: "Processando...",
    l29: "Pedido falhou",
    l30: "Aguardando restaurante",
    l31: "Restaurante não aceitou",
    l32: "Mesa não aberta",
    l33: "Mesa a pagar",
    l34: "Limite de pedidos excedido",
    l35: "Quantidade excedida",
    l36: "Fora do horário",
    l37: "Tempo de pedido expirado",
    l38: "Esgotado",
    l39: "Restaurante não aceitou",
    l40: "Preparo",
    l41: "Deve selecionar",
    l42: "Min selecionar",
    l43: "Max selecionar",
    l44: "Selecione",
    l45: "Login de membro",
    l46: "Entrar",
    l47: "Cadastrar",
    l48: "Por favor digite o nome",
    l49: "Obter código de verificação",
    l50: "Por favor digite o e-mail",
    l51: "Por favor digite a senha",
    l52: "Sair do membro atual?",
    l53: "Por favor digite e-mail válido",
    l54: "Por favor digite o código",
    l55: "Cadastro realizado com sucesso",
    l56: "Código enviado",
    l57: "Falha ao enviar código",
    l58: "E-mail já cadastrado",
    l59: "Erro no código de verificação",
    l60: "Cadastro falhou",
    l61: "Membro não existe ou senha errada",
    l62: "Sem cupons disponíveis",
    l63: "Por favor faça login primeiro",
    l64: "Limpar",
    l65: "Selecionar cupom",
    l66: "Máx selecionar",
    l67: "Cupom",
    l68: "Desconto do cupom",
    l69: "Concluído",
    l70: "Correio eletrónico",
    l71: "Senha",
    l72: "Digite o nome de utilizador",
    l73: "Digite o endereço de correio eletrónico",
    l74: "Digite o código de verificação",
    l75: "Digite a senha",
    l76: "Selecionado",
    l77: "Selecionar",
    l78: "Adicionado com sucesso",
    l79: "Nenhum cupom de desconto disponível no momento",
    l80: "Alguns cupons expiraram e foram removidos automaticamente",
    l81: "Selecionável no máximo",
    l82: "cupom(ns) de desconto",
    l83: "O valor total do pedido não atende ao requisito do cupom",
    l84: "O valor do desconto não pode ser maior que o total do pedido",
    l85: "Falha ao obter a chave da loja",
    l86: "Login efetuado com sucesso",
    l87: "Falha no login",
    l88: "Falta o número da fatura de consumo do membro",
    l89: "Falha no registo de consumo do membro",
    l90: "Falta o número da loja",
    l91: "A chave da loja está vazia",
    l92: "Falha na análise da chave da loja",
    l93: "Este navegador não suporta a descriptografia AES",
    l94: "Loja não ativada",
    l95: "Digite o nome de utilizador",
    l96: "Falha ao gerar a ligação de pagamento",
    l97: "Quantidade máxima selecionável atingida",
    l98: "Opções",
    l99: "Erro de parâmetro",
    l100: "Obrigatório",
    l101: "Cupom de desconto",
    l102: "Disponível após login",
    l103: "Selecionado",
    l104: "item(ns)",
    l105: "Disponível",
    l106: "0 itens disponíveis",
    l107: "Indisponível",
    l108: "Disponível para este pedido",
    l109: "Pedido com valor acima de",
    l110: "Disponível",
    l111: "Levantamento pessoal",
    l112: "Entrega ao domicílio",
    l113: "Nome completo",
    l114: "Número de telefone",
    l115: "Código postal",
    l116: "Endereço",
    l117: "Hora de retirada",
    l118: "Hora de chegada",
    l119: "Escolhas obrigatórias",
    l120: "Menu fixo",
    l121: "Itens opcionais do menu",
    l122: "Gorjeta",
    l123: "Preço do prato",
    l124: "Taxa de serviço",
    l125: "Taxa de embalagem",
    l126: "unidade(s) mínima(s)",
    l127: "Tudo",
    l128: "Impostos incluídos",
    l129: "Antes de impostos",
    l130: "Digite",
    l131: "Observações personalizadas",
    l132: "Digite as observações",
    l133: "Observações",
    l134: "Selecionar tudo",
    l135: "Valor total",
    l136: "Efetuar pedido",
    l137: "Obtido com sucesso->",
    l138: "Analisado",
    l139: "Esta página mostra apenas os itens pedidos através do código QR. Para visualizar a conta completa, volte e clique no ícone no canto inferior direito.",
  },
  {
    l1: "Đặt món",
    l2: "Điện thoại nhà hàng",
    l3: "Giờ mở cửa",
    l4: "Ngôn ngữ",
    l5: "Số bàn",
    l6: "Tìm kiếm",
    l7: "Trở về",
    l8: "Đơn vị",
    l9: "Combo",
    l10: "Cách làm",
    l11: "Thêm vào giỏ",
    l12: "OK",
    l13: "Phương pháp",
    l14: "Giá thêm",
    l15: "Xác nhận",
    l16: "Hủy",
    l17: "Lưu ý",
    l18: "Giỏ hàng",
    l19: "Chọn tất cả",
    l20: "Đặt hàng",
    l21: "Xóa?",
    l22: "Không có món",
    l23: "Thời gian ăn",
    l24: "Tối đa",
    l25: "Xác nhận đặt hàng?",
    l26: "Vui lòng chọn món trước",
    l27: "Quá nhiều món",
    l28: "Đang đặt...",
    l29: "Đặt hàng thất bại",
    l30: "Chờ nhà hàng",
    l31: "Nhà hàng chưa nhận",
    l32: "Bàn chưa mở",
    l33: "Bàn đang thanh toán",
    l34: "Vượt quá số lần đặt",
    l35: "Số lượng vượt quá",
    l36: "Không trong giờ đặt",
    l37: "Hết thời gian đặt",
    l38: "Hết hàng",
    l39: "Nhà hàng chưa nhận",
    l40: "Cách làm",
    l41: "Phải chọn",
    l42: "Ít nhất",
    l43: "Nhất đa",
    l44: "Vui lòng chọn",
    l45: "Đăng nhập thành viên",
    l46: "Đăng nhập",
    l47: "Đăng ký",
    l48: "Vui lòng nhập tên",
    l49: "Lấy mã xác thực",
    l50: "Vui lòng nhập email",
    l51: "Vui lòng nhập mật khẩu",
    l52: "Đăng xuất tài khoản hiện tại?",
    l53: "Vui lòng nhập đúng định dạng email",
    l54: "Vui lòng nhập mã xác thực",
    l55: "Đăng ký thành công",
    l56: "Đã gửi mã xác thực",
    l57: "Gửi mã xác thực thất bại",
    l58: "Email đã được đăng ký",
    l59: "Lỗi mã xác thực",
    l60: "Đăng ký thất bại",
    l61: "Thành viên không tồn tại hoặc sai mật khẩu",
    l62: "Không có ưu đãi nào",
    l63: "Vui lòng đăng nhập trước",
    l64: "Xóa trắng",
    l65: "Chọn ưu đãi",
    l66: "Tối đa chọn",
    l67: "Ưu đãi",
    l68: "Giảm giá ưu đãi",
    l69: "Hoàn tất",
    l70: "Thư điện tử",
    l71: "Mật khẩu",
    l72: "Nhập tên người dùng",
    l73: "Nhập địa chỉ thư điện tử",
    l74: "Nhập mã xác minh",
    l75: "Nhập mật khẩu",
    l76: "Đã chọn",
    l77: "Lựa chọn",
    l78: "Thêm thành công",
    l79: "Hiện không có phiếu giảm giá nào",
    l80: "Một số phiếu giảm giá đã hết hạn và được xóa tự động",
    l81: "Lựa chọn tối đa",
    l82: "phiếu giảm giá",
    l83: "Tổng giá trị đơn hàng chưa đạt điều kiện sử dụng phiếu giảm giá này",
    l84: "Số tiền giảm giá không được lớn hơn tổng đơn hàng",
    l85: "Lỗi lấy khóa cửa hàng",
    l86: "Đăng nhập thành công",
    l87: "Đăng nhập thất bại",
    l88: "Thiếu số hóa đơn tiêu dùng thành viên",
    l89: "Ghi nhận tiêu dùng thành viên thất bại",
    l90: "Thiếu mã cửa hàng",
    l91: "Khóa cửa hàng trống",
    l92: "Lỗi phân tích khóa cửa hàng",
    l93: "Trình duyệt hiện tại không hỗ trợ giải mã AES",
    l94: "Cửa hàng chưa được kích hoạt",
    l95: "Vui lòng nhập tên người dùng",
    l96: "Lỗi tạo liên kết thanh toán",
    l97: "Đã đạt số lượng tối đa có thể chọn",
    l98: "Tùy chọn",
    l99: "Lỗi tham số",
    l100: "Bắt buộc",
    l101: "Phiếu giảm giá",
    l102: "Sử dụng được sau khi đăng nhập",
    l103: "Đã chọn",
    l104: "món",
    l105: "Có sẵn",
    l106: "0 món có sẵn",
    l107: "Không khả dụng",
    l108: "Dùng được cho đơn hàng này",
    l109: "Đơn hàng có giá trị trên",
    l110: "Có sẵn",
    l111: "Đến lấy",
    l112: "Giao hàng tận nơi",
    l113: "Họ và tên",
    l114: "Số điện thoại",
    l115: "Mã bưu chính",
    l116: "Địa chỉ",
    l117: "Giờ nhận hàng",
    l118: "Giờ đến",
    l119: "Các lựa chọn bắt buộc",
    l120: "Bộ món cố định",
    l121: "Các hạng mục bộ món tùy chọn",
    l122: "Tiền boa",
    l123: "Giá món ăn",
    l124: "Phí dịch vụ",
    l125: "Phí đóng gói",
    l126: "sản phẩm tối thiểu",
    l127: "Tất cả",
    l128: "Đã bao gồm thuế",
    l129: "Chưa bao gồm thuế",
    l130: "Vui lòng nhập",
    l131: "Ghi chú tùy chỉnh",
    l132: "Vui lòng nhập ghi chú",
    l133: "Ghi chú",
    l134: "Chọn tất cả",
    l135: "Tổng cộng",
    l136: "Gửi đơn hàng",
    l137: "Lấy thành công->",
    l138: "Đã phân tích",
    l139: "Trang này chỉ hiển thị các món được đặt thông qua mã QR. Để xem hóa đơn đầy đủ, hãy quay lại và nhấp vào biểu tượng ở góc dưới cùng bên phải.",
  },
  {
    l1: "Bestellen",
    l2: "Restaurant Telefon",
    l3: "Öffnungszeiten",
    l4: "Sprache",
    l5: "Tischnummer",
    l6: "Suchen",
    l7: "Zurück",
    l8: "Einheit",
    l9: "Menü",
    l10: "Zubereitung",
    l11: "Zum Warenkorb hinzufügen",
    l12: "OK",
    l13: "Methode",
    l14: "Zusatzpreis",
    l15: "Bestätigen",
    l16: "Abbrechen",
    l17: "Tipps",
    l18: "Warenkorb",
    l19: "Alles auswählen",
    l20: "Bestellen",
    l21: "Löschen?",
    l22: "Kein Essen",
    l23: "Essenzeit",
    l24: "Max",
    l25: "Bestellung bestätigen?",
    l26: "Wählen Sie Gerichte zuerst",
    l27: "Zu viele Gerichte",
    l28: "Wird verarbeitet...",
    l29: "Bestellung fehlgeschlagen",
    l30: "Warten auf Restaurant",
    l31: "Restaurant nicht akzeptiert",
    l32: "Tisch nicht geöffnet",
    l33: "Tisch bei der Abrechnung",
    l34: "Maximale Bestellungen überschritten",
    l35: "Menge überschritten",
    l36: "Außerhalb der Bestellzeiten",
    l37: "Bestellzeit abgelaufen",
    l38: "Ausverkauft",
    l39: "Restaurant nicht akzeptiert",
    l40: "Zubereitung",
    l41: "Muss wählen",
    l42: "Min wählen",
    l43: "Max wählen",
    l44: "Wählen Sie",
    l45: "Mitglieder-Login",
    l46: "Login",
    l47: "Registrieren",
    l48: "Bitte Namen eingeben",
    l49: "Bestätigungscode anfordern",
    l50: "Bitte E-Mail eingeben",
    l51: "Bitte Passwort eingeben",
    l52: "Aktuelles Mitglied abmelden?",
    l53: "Bitte gültige E-Mail eingeben",
    l54: "Bitte Bestätigungscode eingeben",
    l55: "Registrierung erfolgreich",
    l56: "Code gesendet",
    l57: "Code senden fehlgeschlagen",
    l58: "E-Mail bereits registriert",
    l59: "Bestätigungscode falsch",
    l60: "Registrierung fehlgeschlagen",
    l61: "Mitglied nicht gefunden oder Passwort falsch",
    l62: "Keine Gutscheine verfügbar",
    l63: "Bitte zuerst anmelden",
    l64: "Leeren",
    l65: "Gutschein wählen",
    l66: "Maximal auswählen",
    l67: "Gutschein",
    l68: "Gutscheinrabatt",
    l69: "Abgeschlossen",
    l70: "E‑Mail",
    l71: "Passwort",
    l72: "Geben Sie den Benutzernamen ein",
    l73: "Geben Sie die E‑Mail‑Adresse ein",
    l74: "Geben Sie den Bestätigungscode ein",
    l75: "Geben Sie das Passwort ein",
    l76: "Ausgewählt",
    l77: "Auswählen",
    l78: "Erfolgreich hinzugefügt",
    l79: "Derzeit sind keine Rabattgutscheine verfügbar",
    l80: "Einige Gutscheine sind abgelaufen und automatisch entfernt worden",
    l81: "Maximal auswählbar",
    l82: "Gutschein(e)",
    l83: "Der Bestellwert entspricht nicht der Gutscheinvoraussetzung",
    l84: "Der Rabattbetrag darf den Bestellwert nicht übersteigen",
    l85: "Abrufen des Filialschlüssels fehlgeschlagen",
    l86: "Anmeldung erfolgreich",
    l87: "Anmeldung fehlgeschlagen",
    l88: "Mitgliedsverbrauchsrechnungsnummer fehlt",
    l89: "Mitgliedsverbrauchsprotokoll fehlgeschlagen",
    l90: "Filialnummer fehlt",
    l91: "Schlüssel der Filiale ist leer",
    l92: "Analyse des Schlüssels fehlgeschlagen",
    l93: "Dieser Browser unterstützt keine AES‑Entschlüsselung",
    l94: "Filiale nicht aktiviert",
    l95: "Bitte geben Sie den Benutzernamen ein",
    l96: "Zahlungslink konnte nicht erstellt werden",
    l97: "Maximale Anzahl auswählbarer Artikel erreicht",
    l98: "Optionen",
    l99: "Parameterfehler",
    l100: "Pflichtfeld",
    l101: "Rabattgutschein",
    l102: "Nach Anmeldung verfügbar",
    l103: "Ausgewählt",
    l104: "Stück",
    l105: "Verfügbar",
    l106: "0 Stück verfügbar",
    l107: "Nicht verfügbar",
    l108: "Für diese Bestellung verfügbar",
    l109: "Bestellung mit einem Betrag über",
    l110: "Verfügbar",
    l111: "Selbstabholung",
    l112: "Hauslieferung",
    l113: "Vollständiger Name",
    l114: "Telefonnummer",
    l115: "Postleitzahl",
    l116: "Adresse",
    l117: "Abholzeit",
    l118: "Ankunftszeit",
    l119: "Pflichtauswahlen",
    l120: "Festmenü",
    l121: "Optionale Menüpunkte",
    l122: "Trinkgeld",
    l123: "Gerichtspreis",
    l124: "Servicegebühr",
    l125: "Verpackungsgebühr",
    l126: "Stück Mindestbestellmenge",
    l127: "Alle",
    l128: "Inkl. MwSt.",
    l129: "Ohne MwSt.",
    l130: "Bitte eingeben",
    l131: "Benutzerdefinierte Notizen",
    l132: "Notizen eingeben",
    l133: "Notizen",
    l134: "Alle auswählen",
    l135: "Gesamtbetrag",
    l136: "Bestellung aufgeben",
    l137: "Erfolgreich abgerufen->",
    l138: "Analysiert",
    l139: "Diese Seite zeigt nur per QR-Code bestellte Gerichte an. Um die vollständige Rechnung zu sehen, gehen Sie zurück und klicken Sie auf das Symbol unten rechts.",
  },
  {
    l1: "주문",
    l2: "레스토랑 전화",
    l3: "영업 시간",
    l4: "언어",
    l5: "테이블 번호",
    l6: "검색",
    l7: "돌아가기",
    l8: "단위",
    l9: "세트 메뉴",
    l10: "조리 방법",
    l11: "장바구니에 추가",
    l12: "OK",
    l13: "방법",
    l14: "추가 요금",
    l15: "확인",
    l16: "취소",
    l17: "팁",
    l18: "장바구니",
    l19: "전체 선택",
    l20: "주문",
    l21: "삭제?",
    l22: "음식 없음",
    l23: "식사 시간",
    l24: "최대",
    l25: "주문 확인?",
    l26: "메뉴를 선택하세요",
    l27: "메뉴가 너무 많습니다",
    l28: "주문 중...",
    l29: "주문 실패",
    l30: "레스토랑 대기",
    l31: "레스토랑 미수락",
    l32: "테이블 미개장",
    l33: "테이블 정산 중",
    l34: "주문 횟수 초과",
    l35: "주문 수량 초과",
    l36: "주문 시간 외",
    l37: "주문 시간 만료",
    l38: "매진",
    l39: "레스토랑 미수락",
    l40: "조리 방법",
    l41: "선택해야 함",
    l42: "최소 선택",
    l43: "최대 선택",
    l44: "선택하세요",
    l45: "회원 로그인",
    l46: "로그인",
    l47: "회원가입",
    l48: "이름을 입력하세요",
    l49: "인증코드 받기",
    l50: "이메일을 입력하세요",
    l51: "비밀번호를 입력하세요",
    l52: "현재 회원 로그아웃 하시겠습니까?",
    l53: "올바른 이메일 형식을 입력하세요",
    l54: "인증코드를 입력하세요",
    l55: "가입 성공",
    l56: "인증코드 전송됨",
    l57: "인증코드 전송 실패",
    l58: "이미 가입된 이메일입니다",
    l59: "인증코드 오류",
    l60: "가입 실패",
    l61: "회원이 없거나 비밀번호 오류",
    l62: "사용 가능한 쿠폰 없음",
    l63: "먼저 회원 로그인하세요",
    l64: "비우기",
    l65: "쿠폰 선택",
    l66: "최대 선택",
    l67: "쿠폰",
    l68: "쿠폰 할인",
    l69: "완료",
    l70: "전자 우편",
    l71: "비밀번호",
    l72: "사용자 이름을 입력하십시오",
    l73: "전자 우편 주소를 입력하십시오",
    l74: "인증 코드를 입력하십시오",
    l75: "비밀번호를 입력하십시오",
    l76: "선택됨",
    l77: "선택",
    l78: "성공적으로 추가됨",
    l79: "현재 사용 가능한 할인 쿠폰이 없습니다",
    l80: "일부 쿠폰이 만료되어 자동으로 제거되었습니다",
    l81: "최대 선택 가능",
    l82: "장의 쿠폰",
    l83: "주문 금액이 쿠폰 사용 조건에 도달하지 않았습니다",
    l84: "할인 금액은 주문 금액보다 클 수 없습니다",
    l85: "매장 키 가져오기 실패",
    l86: "로그인 성공",
    l87: "로그인 실패",
    l88: "회원 소비 송장 번호 누락",
    l89: "회원 소비 기록 실패",
    l90: "매장 번호 누락",
    l91: "매장 키가 비어 있습니다",
    l92: "매장 키 분석 실패",
    l93: "이 브라우저는 AES 복호화를 지원하지 않습니다",
    l94: "매장이 개설되지 않았습니다",
    l95: "사용자 이름을 입력하십시오",
    l96: "결제 링크 생성 실패",
    l97: "선택 가능한 최대 수량에 도달했습니다",
    l98: "옵션",
    l99: "매개 변수 오류",
    l100: "필수 항목",
    l101: "할인 쿠폰",
    l102: "로그인 후 사용 가능",
    l103: "선택됨",
    l104: "개",
    l105: "사용 가능",
    l106: "0개 사용 가능",
    l107: "사용 불가",
    l108: "이 주문에서 사용 가능",
    l109: "주문 금액이",
    l110: "사용 가능",
    l111: "직접 수령",
    l112: "배달",
    l113: "성명",
    l114: "전화 번호",
    l115: "우편 번호",
    l116: "주소",
    l117: "수령 시간",
    l118: "도착 시간",
    l119: "필수 선택 옵션",
    l120: "고정 세트 메뉴",
    l121: "선택 가능 세트 메뉴 항목",
    l122: "팁",
    l123: "요리 가격",
    l124: "서비스 요금",
    l125: "포장 요금",
    l126: "개 이상부터",
    l127: "전체",
    l128: "세금 포함",
    l129: "세금 전",
    l130: "입력하십시오",
    l131: "사용자 정의 비고",
    l132: "비고를 입력하십시오",
    l133: "비고",
    l134: "전체 선택",
    l135: "총액",
    l136: "주문하기",
    l137: "성공적으로 가져옴->",
    l138: "분석됨",
    l139: "이 페이지에는 QR 코드로 주문한 메뉴만 표시됩니다. 전체 영수증을 보려면 돌아가서 오른쪽 하단 아이콘을 누르세요.",
  },
  {
    l1: "ສັ່ງອາຫານ",
    l2: "ໂທລະສັບຮ້ານອາຫານ",
    l3: "ເວລາປະກາດ",
    l4: "ພາສາ",
    l5: "ເລກຕາຕະລາງ",
    l6: "ຄົ້ນຫາ",
    l7: "ກັບຄືນ",
    l8: "ຫົວໜ່ວຍ",
    l9: "ເຄື່ອງປະດັບ",
    l10: "ວິທີການກະກຽມ",
    l11: "ເພີ່ມເຂົ້າສ່ວນ",
    l12: "ເຂົ້າໃຈແລ້ວ",
    l13: "ວິທີ",
    l14: "ລາຄາພິເສດ",
    l15: "ຢືນຢັນ",
    l16: "ຍົກເລີກ",
    l17: "ຄຳແນະນຳ",
    l18: "ຖັງ",
    l19: "ເລືອກທັງໝົດ",
    l20: "ສັ່ງອາຫານ",
    l21: "ລຶບ?",
    l22: "ບໍ່ມີອາຫານ",
    l23: "ເວລາກິນອາຫານ",
    l24: "ສູງສຸດ",
    l25: "ຢືນຢັນສັ່ງອາຫານ?",
    l26: "ກະລຸນາເລືອກອາຫານ",
    l27: "ອາຫານຫຼາຍເກີນໄປ",
    l28: "ກຳລັງສັ່ງ...",
    l29: "ສັ່ງລົ້ມເຫຼວ",
    l30: "ລໍຖ້າຮ້ານ",
    l31: "ຮ້ານອາຫານບໍ່ຮັບ",
    l32: "ຕາຕະລາງບໍ່ເປີດ",
    l33: "ຕາຕະລາງກຳລັງການຈ່າຍເງິນ",
    l34: "ລະດັບສັ່ງເກີນ",
    l35: "ຈຳນວນເກີນ",
    l36: "ບໍ່ຢູ່ໃນເວລາສັ່ງ",
    l37: "ເວລາສັ່ງໝົດ",
    l38: "ແລ້ວ",
    l39: "ຮ້ານອາຫານບໍ່ຮັບ",
    l40: "ວິທີການກະກຽມ",
    l41: "ຕ້ອງເລືອກ",
    l42: "ຂັ້ນຕ່ຳ",
    l43: "ສູງສຸດ",
    l44: "ກະລຸນາເລືອກ",
    l45: "ເຂົ້າສູ່ລະບົບສະມາຊິກ",
    l46: "ເຂົ້າສູ່ລະບົບ",
    l47: "ລົງທະບຽນ",
    l48: "ກະລຸນາປ້ອນຊື່",
    l49: "ຮັບລະຫັດຢືນຢັນ",
    l50: "ກະລຸນາປ້ອນອີເມວ",
    l51: "ກະລຸນາປ້ອນລະຫັດຜ່ານ",
    l52: "ອອກຈາກລະບົບສະມາຊິກປັດຈຸບັນ?",
    l53: "ກະລຸນາປ້ອນຮູບແບບອີເມວທີ່ຖືກຕ້ອງ",
    l54: "ກະລຸນາປ້ອນລະຫັດຢືນຢັນ",
    l55: "ລົງທະບຽນສຳເລັດ",
    l56: "ສົ່ງລະຫັດແລ້ວ",
    l57: "ສົ່ງລະຫັດບໍ່ສຳເລັດ",
    l58: "ອີເມວນີ້ລົງທະບຽນແລ້ວ",
    l59: "ລະຫັດຢືນຢັນບໍ່ຖືກຕ້ອງ",
    l60: "ລົງທະບຽນບໍ່ສຳເລັດ",
    l61: "ບໍ່ພົບສະມາຊິກ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ",
    l62: "ບໍ່ມີຄູປອງ",
    l63: "ກະລຸນາເຂົ້າສູ່ລະບົບສະມາຊິກກ່ອນ",
    l64: "ລ້າງ",
    l65: "ເລືອກຄູປອງ",
    l66: "ສູງສຸດ",
    l67: "ຄູປອງ",
    l68: "ສ່ວນຫຼຸດ",
    l69: "ສຳເລັດ",
    l70: "ອີເມວ",
    l71: "ລະຫັດຜ່ານ",
    l72: "ປ້ອນຊື່ຜູ້ໃຊ້",
    l73: "ປ້ອນທີ່ຢູ່ອີເມວ",
    l74: "ປ້ອນລະຫັດຢັ້ງຢືນ",
    l75: "ປ້ອນລະຫັດຜ່ານ",
    l76: "ເລືອກແລ້ວ",
    l77: "ເລືອກ",
    l78: "ເພີ່ມສຳເລັດ",
    l79: "ບໍ່ມີຄູປອງສ່ວນຫຼຸດທີ່ໃຊ້ໄດ້ໃນປະຈຸບັນ",
    l80: "ຄູປອງບາງອັນໝົດອາຍຸແລ້ວ ຖືກລົບອັດຕະໂນມັດ",
    l81: "ສາມາດເລືອກໄດ້ສູງສຸດ",
    l82: "ຄູປອງ",
    l83: "ຈຳນວນເງິນອໍເດີຍັງບໍ່ບັນລຸເງື່ອນໄຂນຳໃຊ້ຄູປອງນີ້",
    l84: "ຈຳນວນເງິນສ່ວນຫຼຸດບໍ່ສາມາດໃຫຍ່ກວ່າອໍເດີໄດ້",
    l85: "ເອົາລະຫັດຮ້ານບໍ່ສຳເລັດ",
    l86: "ເຂົ້າສູ່ລະບົບສຳເລັດ",
    l87: "ເຂົ້າສູ່ລະບົບບໍ່ສຳເລັດ",
    l88: "ຂາດເລກທີໃບບິນໃຊ້ຈ່າຍສະມາຊິກ",
    l89: "ບັນທຶກການໃຊ້ຈ່າຍສະມາຊິກບໍ່ສຳເລັດ",
    l90: "ຂາດລະຫັດຮ້ານ",
    l91: "ລະຫັດຮ້ານເປັນຄ່າວ່າງ",
    l92: "ວິເຄາະລະຫັດຮ້ານບໍ່ສຳເລັດ",
    l93: "ເບຣຸເຊີໃນປະຈຸບັນບໍ່ຮອງຮັບ ຖອດລະຫັດ AES",
    l94: "ຮ້ານຍັງບໍ່ທັນເປີດໃຫ້ບໍລິການ",
    l95: "ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້",
    l96: "ສ້າງລິ້ງຈ່າຍເງິນບໍ່ສຳເລັດ",
    l97: "ບັນລຸຈຳນວນສູງສຸດທີ່ສາມາດເລືອກໄດ້",
    l98: "ທາງເລືອກ",
    l99: "ຄ່າພາຣາມິເຕີຜິດ",
    l100: "ຕ້ອງການປ້ອນ",
    l101: "ຄູປອງສ່ວນຫຼຸດ",
    l102: "ໃຊ້ໄດ້ຫຼັງຈາກເຂົ້າສູ່ລະບົບ",
    l103: "ເລືອກແລ້ວ",
    l104: "ຊິ້ນ",
    l105: "ໃຊ້ໄດ້",
    l106: "0 ຊິ້ນ ໃຊ້ໄດ້",
    l107: "ບໍ່ສາມາດໃຊ້",
    l108: "ໃຊ້ໄດ້ສຳລັບອໍເດີນີ້",
    l109: "ອໍເດີມີມູນຄ່າເກີນ",
    l110: "ໃຊ້ໄດ້",
    l111: "ມາຮັບເອງ",
    l112: "ສົ່ງຫາບ້ານ",
    l113: "ຊື່ ແລະ ນາມສະກຸນ",
    l114: "ເບີໂທລະສັບ",
    l115: "ລະຫັດໄປສະນີ",
    l116: "ທີ່ຢູ່",
    l117: "ເວລາຮັບອາຫານ",
    l118: "ເວລາຮອດ",
    l119: "ເລືອກທາງເລືອກທີ່ຕ້ອງການ",
    l120: "ຊຸດອາຫານຄົງທີ່",
    l121: "ລາຍການເລືອກໃນ ຊຸດອາຫານ",
    l122: "ທິດເງິນ",
    l123: "ລາຄາເມນູ",
    l124: "ຄ່າບໍລິການ",
    l125: "ຄ່າຫຸ້ມຫໍ່",
    l126: "ຊິ້ນຂັ້ນຕ່ຳ",
    l127: "ທັງໝົດ",
    l128: "ລວມພາສີ",
    l129: "ກ່ອນພາສີ",
    l130: "ກະລຸນາປ້ອນ",
    l131: "ໝາຍເຫດ ສ່ວນບຸກຄົນ",
    l132: "ກະລຸນາປ້ອນໝາຍເຫດ",
    l133: "ໝາຍເຫດ",
    l134: "ເລືອກທັງໝົດ",
    l135: "ລວມຄ່າໃຊ້ຈ່າຍ",
    l136: "ຢືນຢັນອໍເດີ",
    l137: "ເອົາມາສຳເລັດຮູບ->",
    l138: "ວິເຄາະແລ້ວ",
    l139: "ໜ້ານີ້ສະແດງພຽງແຕ່ອາຫານທີ່ສັ່ງໂດຍສະແກນລະຫັດ QR ເທົ່ານັ້ນ. ເພື່ອເບິ່ງໃບບິນທັງໝົດ, ໃຫ້ກັບຄືນແລະກດໄອຄອນຢູ່ມຸມລຸ່ມຂວາ.",
  },
  {
    l1: "Заказ",
    l2: "Телефон ресторана",
    l3: "Время работы",
    l4: "Язык",
    l5: "Номер стола",
    l6: "Поиск",
    l7: "Назад",
    l8: "Единица",
    l9: "Комбо",
    l10: "Приготовление",
    l11: "Добавить в корзину",
    l12: "OK",
    l13: "Метод",
    l14: "Дополнительная цена",
    l15: "Подтвердить",
    l16: "Отмена",
    l17: "Подсказки",
    l18: "Корзина",
    l19: "Выбрать все",
    l20: "Заказать",
    l21: "Удалить?",
    l22: "Нет еды",
    l23: "Время приема пищи",
    l24: "Максимум",
    l25: "Подтвердить заказ?",
    l26: "Выберите блюда сначала",
    l27: "Слишком много блюд",
    l28: "Обрабатывается...",
    l29: "Заказ не удался",
    l30: "Ожидание ресторана",
    l31: "Ресторан не принял",
    l32: "Стол не открыт",
    l33: "Стол в процессе оплаты",
    l34: "Превышено число заказов",
    l35: "Количество превышено",
    l36: "Вне времени заказа",
    l37: "Время заказа истекло",
    l38: "Закончилось",
    l39: "Ресторан не принял",
    l40: "Приготовление",
    l41: "Должно выбираться",
    l42: "Минимум",
    l43: "Максимум",
    l44: "Выберите",
    l45: "Вход для членов",
    l46: "Войти",
    l47: "Регистрация",
    l48: "Введите имя",
    l49: "Получить код подтверждения",
    l50: "Введите адрес эл. почты",
    l51: "Введите пароль",
    l52: "Выйти из текущего аккаунта?",
    l53: "Введите корректный адрес почты",
    l54: "Введите код подтверждения",
    l55: "Регистрация успешна",
    l56: "Код отправлен",
    l57: "Не удалось отправить код",
    l58: "Почта уже зарегистрирована",
    l59: "Ошибка кода подтверждения",
    l60: "Регистрация не удалась",
    l61: "Член не найден или неверный пароль",
    l62: "Нет доступных купонов",
    l63: "Войдите сначала как член",
    l64: "Очистить",
    l65: "Выбрать купон",
    l66: "Макс. выбор",
    l67: "Купон",
    l68: "Скидка по купону",
    l69: "Завершено",
    l70: "Электронная почта",
    l71: "Пароль",
    l72: "Введите имя пользователя",
    l73: "Введите адрес электронной почты",
    l74: "Введите проверочный код",
    l75: "Введите пароль",
    l76: "Выбрано",
    l77: "Выбрать",
    l78: "Успешно добавлено",
    l79: "В настоящее время нет доступных купонов на скидку",
    l80: "Некоторые купоны истекли и были автоматически удалены",
    l81: "Максимально можно выбрать",
    l82: "купон(а/ов)",
    l83: "Сумма заказа не соответствует условиям использования купона",
    l84: "Сумма скидки не может быть больше суммы заказа",
    l85: "Не удалось получить ключ магазина",
    l86: "Вход выполнен успешно",
    l87: "Ошибка входа",
    l88: "Отсутствует номер счёта‑потребления участника",
    l89: "Не удалось зарегистрировать потребление участника",
    l90: "Отсутствует номер магазина",
    l91: "Ключ магазина пуст",
    l92: "Не удалось обработать ключ магазина",
    l93: "Этот браузер не поддерживает расшифровку AES",
    l94: "Магазин не активирован",
    l95: "Введите имя пользователя",
    l96: "Не удалось сформировать ссылку на оплату",
    l97: "Достигнуто максимальное количество для выбора",
    l98: "Параметры выбора",
    l99: "Ошибка параметра",
    l100: "Обязательное поле",
    l101: "Купон на скидку",
    l102: "Доступно после входа",
    l103: "Выбрано",
    l104: "шт.",
    l105: "Доступно",
    l106: "0 шт. доступно",
    l107: "Недоступно",
    l108: "Доступно для этого заказа",
    l109: "При сумме заказа от",
    l110: "Доступно",
    l111: "Самовывоз",
    l112: "Доставка на дом",
    l113: "Полное имя",
    l114: "Номер телефона",
    l115: "Почтовый индекс",
    l116: "Адрес",
    l117: "Время получения",
    l118: "Время прибытия",
    l119: "Обязательные для выбора",
    l120: "Фиксированный комплекс",
    l121: "Варианты выбора в комплексе",
    l122: "Чаевые",
    l123: "Цена блюда",
    l124: "Плата за обслуживание",
    l125: "Плата за упаковку",
    l126: "шт. минимум",
    l127: "Всё",
    l128: "С учётом налога",
    l129: "Без учёта налога",
    l130: "Введите",
    l131: "Особые пожелания",
    l132: "Введите примечание",
    l133: "Примечание",
    l134: "Выбрать всё",
    l135: "Итого к оплате",
    l136: "Оформить заказ",
    l137: "Успешно получено->",
    l138: "Обработано",
    l139: "На этой странице отображаются только блюда, заказанные по QR-коду. Чтобы посмотреть весь счёт, вернитесь и нажмите на иконку в правом нижнем углу.",
  },
  {
    l1: "Bestille",
    l2: "Restaurant telefon",
    l3: "Åpningstider",
    l4: "Språk",
    l5: "Bordnummer",
    l6: "Søk",
    l7: "Tilbake",
    l8: "Enhet",
    l9: "Menu",
    l10: "Fremstilling",
    l11: "Legg til handlekurv",
    l12: "OK",
    l13: "Metode",
    l14: "Ekstra pris",
    l15: "Bekreft",
    l16: "Avbryt",
    l17: "Tips",
    l18: "Handlekurv",
    l19: "Velg alle",
    l20: "Bestille",
    l21: "Slette?",
    l22: "Ingen mat",
    l23: "Spise tid",
    l24: "Maks",
    l25: "Bekreft ordre?",
    l26: "Velg retter først",
    l27: "For mange retter",
    l28: "Behandler...",
    l29: "Ordre mislyktes",
    l30: "Venter på restaurant",
    l31: "Restaurant ikke akseptert",
    l32: "Bord ikke åpent",
    l33: "Bord i betaling",
    l34: "Oversteget maks ordre",
    l35: "Antall oversteget",
    l36: "Utenfor ordre tid",
    l37: "Ordre tid utløpt",
    l38: "Utsolgt",
    l39: "Restaurant ikke akseptert",
    l40: "Fremstilling",
    l41: "Må velge",
    l42: "Min velge",
    l43: "Max velge",
    l44: "Velg",
    l45: "Medlems pålogging",
    l46: "Logg inn",
    l47: "Registrer deg",
    l48: "Vennligst skriv navn",
    l49: "Få bekreftelseskode",
    l50: "Vennligst skriv e-post",
    l51: "Vennligst skriv passord",
    l52: "Logg ut nåværende medlem?",
    l53: "Vennligst skriv gyldig e-post",
    l54: "Vennligst skriv bekreftelseskode",
    l55: "Registrering vellykket",
    l56: "Kode sendt",
    l57: "Kodesending mislyktes",
    l58: "E-post allerede registrert",
    l59: "Bekreftelseskodefeil",
    l60: "Registrering mislyktes",
    l61: "Medlem finnes ikke eller feil passord",
    l62: "Ingen kuponger tilgjengelig",
    l63: "Vennligst logg inn først",
    l64: "Tøm",
    l65: "Velg kupong",
    l66: "Maks valg",
    l67: "Kupong",
    l68: "Kupongrabatt",
    l69: "Fullført",
    l70: "E‑post",
    l71: "Passord",
    l72: "Angi brukernavn",
    l73: "Angi e‑postadresse",
    l74: "Angi bekreftelseskode",
    l75: "Angi passord",
    l76: "Valgt",
    l77: "Velg",
    l78: "Lagt til vellykket",
    l79: "Ingen rabattkuponger tilgjengelig for øyeblikket",
    l80: "Noen kuponger er utløpt og fjernet automatisk",
    l81: "Maksimalt antall for valg",
    l82: "kupong(er)",
    l83: "Bestillingsbeløpet oppfyller ikke betingelsene for kupongen",
    l84: "Rabattbeløpet kan ikke være større enn bestillingsbeløpet",
    l85: "Henting av butøkkel mislyktes",
    l86: "Innlogging vellykket",
    l87: "Innlogging mislyktes",
    l88: "Mangler medlemsforbruksfakturanummer",
    l89: "Registrering av medlemsforbruk mislyktes",
    l90: "Mangler butikknummer",
    l91: "Butøkkelen er tom",
    l92: "Analyse av butøkkelen mislyktes",
    l93: "Denne nettleseren støtter ikke AES‑dekryptering",
    l94: "Butikken er ikke aktivert",
    l95: "Vennligst angi brukernavn",
    l96: "Generering av betalingslenke mislyktes",
    l97: "Maksimalt antall valgbare er nådd",
    l98: "Valg",
    l99: "Parameterfeil",
    l100: "Obligatorisk",
    l101: "Rabattkupong",
    l102: "Tilgjengelig etter innlogging",
    l103: "Valgt",
    l104: "stk",
    l105: "Tilgjengelig",
    l106: "0 stk tilgjengelig",
    l107: "Ikke tilgjengelig",
    l108: "Tilgjengelig for denne bestillingen",
    l109: "Ved bestilling over",
    l110: "Tilgjengelig",
    l111: "Selvhenting",
    l112: "Hjemlevering",
    l113: "Fullt navn",
    l114: "Telefonnummer",
    l115: "Postnummer",
    l116: "Adresse",
    l117: "Hentingstid",
    l118: "Ankomsttid",
    l119: "Påkrevde valg",
    l120: "Fast meny",
    l121: "Valgfrie menyvalg",
    l122: "Dricks",
    l123: "Rettpris",
    l124: "Servicegebyr",
    l125: "Emballasjegebyr",
    l126: "stk. minimum",
    l127: "Alle",
    l128: "Mva inkludert",
    l129: "Før mva",
    l130: "Vennligst angi",
    l131: "Tilpassede merknader",
    l132: "Fyll ut merknader",
    l133: "Merknader",
    l134: "Velg alle",
    l135: "Totalbeløp",
    l136: "Bekreft bestilling",
    l137: "Vellykket henting->",
    l138: "Analysert",
    l139: "Denne siden viser kun retter bestilt via QR-kode. For å se hele regningen, gå tilbake og trykk på ikonet nederst til høyre.",
  },
  {
    l1: "Zamów",
    l2: "Telefon restauracji",
    l3: "Godziny otwarcia",
    l4: "Język",
    l5: "Numer stolika",
    l6: "Szukaj",
    l7: "Wróć",
    l8: "Jednostka",
    l9: "Menu",
    l10: "Przygotowanie",
    l11: "Dodaj do koszyka",
    l12: "OK",
    l13: "Metoda",
    l14: "Dodatkowa cena",
    l15: "Potwierdź",
    l16: "Anuluj",
    l17: "Porady",
    l18: "Koszyk",
    l19: "Zaznacz wszystko",
    l20: "Zamów",
    l21: "Usunąć?",
    l22: "Brak jedzenia",
    l23: "Czas jedzenia",
    l24: "Maksymalnie",
    l25: "Potwierdzić zamówienie?",
    l26: "Wybierz dania najpierw",
    l27: "Za dużo dań",
    l28: "Przetwarzanie...",
    l29: "Zamówienie nieudane",
    l30: "Oczekiwanie na restaurację",
    l31: "Restauracja nie zaakceptowała",
    l32: "Stół nie otwarty",
    l33: "Stół w trakcie płatności",
    l34: "Przekroczono limit zamówień",
    l35: "Ilość przekroczona",
    l36: "Poza godzinami zamówień",
    l37: "Czas zamówienia wygasł",
    l38: "Wyprzedane",
    l39: "Restauracja nie zaakceptowała",
    l40: "Przygotowanie",
    l41: "Musisz wybrać",
    l42: "Min wybrać",
    l43: "Max wybrać",
    l44: "Wybierz",
    l45: "Logowanie członka",
    l46: "Zaloguj",
    l47: "Zarejestruj",
    l48: "Proszę wpisać imię",
    l49: "Uzyskaj kod weryfikacyjny",
    l50: "Proszę wpisać email",
    l51: "Proszę wpisać hasło",
    l52: "Wylogować bieżącego członka?",
    l53: "Proszę wpisać poprawny email",
    l54: "Proszę wpisać kod weryfikacyjny",
    l55: "Rejestracja zakończona pomyślnie",
    l56: "Kod wysłany",
    l57: "Nie udało się wysłać kodu",
    l58: "Email już zarejestrowany",
    l59: "Błąd kodu weryfikacyjnego",
    l60: "Rejestracja nie powiodła się",
    l61: "Członek nie istnieje lub błędne hasło",
    l62: "Brak dostępnych kuponów",
    l63: "Najpierw zaloguj się jako członek",
    l64: "Wyczyść",
    l65: "Wybierz kupon",
    l66: "Maks. wybór",
    l67: "Kupon",
    l68: "Rabatu kuponu",
    l69: "Zakończono",
    l70: "Poczta elektroniczna",
    l71: "Hasło",
    l72: "Wprowadź nazwę użytkownika",
    l73: "Wprowadź adres poczty elektronicznej",
    l74: "Wprowadź kod weryfikacyjny",
    l75: "Wprowadź hasło",
    l76: "Wybrano",
    l77: "Wybierz",
    l78: "Dodano pomyślnie",
    l79: "Obecnie nie ma dostępnych kuponów rabatowych",
    l80: "Niektóre kupony wygasły i zostały automatycznie usunięte",
    l81: "Maksymalnie do wyboru",
    l82: "kupon(y)",
    l83: "Wartość zamówienia nie spełnia warunków wykorzystania kuponu",
    l84: "Wartość zniżki nie może być większa niż wartość zamówienia",
    l85: "Nie udało się pobrać klucza sklepu",
    l86: "Zalogowano pomyślnie",
    l87: "Logowanie nie powiodło się",
    l88: "Brak numeru faktury zużycia członka",
    l89: "Nie udało się zapisać zużycia członka",
    l90: "Brak numeru sklepu",
    l91: "Klucz sklepu jest pusty",
    l92: "Analiza klucza sklepu nie powiodła się",
    l93: "Ta przeglądarka nie obsługuje odszyfrowywania AES",
    l94: "Sklep nie został aktywowany",
    l95: "Wprowadź nazwę użytkownika",
    l96: "Nie udało się wygenerować linku płatności",
    l97: "Osiągnięto maksymalną liczbę sztuk do wyboru",
    l98: "Opcje",
    l99: "Błąd parametru",
    l100: "Pole wymagane",
    l101: "Kupon rabatowy",
    l102: "Dostępne po zalogowaniu",
    l103: "Wybrano",
    l104: "szt.",
    l105: "Dostępne",
    l106: "0 szt. dostępnych",
    l107: "Niedostępne",
    l108: "Dostępne dla tego zamówienia",
    l109: "Przy zamówieniu powyżej",
    l110: "Dostępne",
    l111: "Odbiór osobisty",
    l112: "Dostawa do domu",
    l113: "Imię i nazwisko",
    l114: "Numer telefonu",
    l115: "Kod pocztowy",
    l116: "Adres",
    l117: "Godzina odbioru",
    l118: "Godzina przyjazdu",
    l119: "Wymagane wybory",
    l120: "Menu stałe",
    l121: "Opcjonalne pozycje menu",
    l122: "Napiwek",
    l123: "Cena dania",
    l124: "Opłata za usługę",
    l125: "Opłata za pakowanie",
    l126: "szt. minimum",
    l127: "Wszystko",
    l128: "Z podatkiem",
    l129: "Przed podatkiem",
    l130: "Wprowadź",
    l131: "Uwagi niestandardowe",
    l132: "Wprowadź uwagi",
    l133: "Uwagi",
    l134: "Zaznacz wszystko",
    l135: "Suma całkowita",
    l136: "Złóż zamówienie",
    l137: "Pobrano pomyślnie->",
    l138: "Przeanalizowano",
    l139: "Ta strona pokazuje tylko dania zamówione za pomocą kodu QR. Aby wyświetlić pełny rachunek, wróć i kliknij ikonę w prawym dolnym rogu.",
  },
  {
    l1: "Mag-order",
    l2: "Telepono ng restawran",
    l3: "Oras ng pagbubukas",
    l4: "Wika",
    l5: "Numero ng mesa",
    l6: "Maghanap",
    l7: "Bumalik",
    l8: "Yunit",
    l9: "Menu",
    l10: "Pagluluto",
    l11: "Idagdag sa cart",
    l12: "OK",
    l13: "Pamamaraan",
    l14: "Karagdagang presyo",
    l15: "Kumpirmahin",
    l16: "Kanselahin",
    l17: "Mga tip",
    l18: "Cart",
    l19: "Piliin ang lahat",
    l20: "Mag-order",
    l21: "Tanggalin?",
    l22: "Walang pagkain",
    l23: "Oras ng pagkain",
    l24: "Max",
    l25: "Kumpirmahin order?",
    l26: "Piliin muna ang mga pagkain",
    l27: "Masyadong maraming pagkain",
    l28: "Nagpoproseso...",
    l29: "Order failed",
    l30: "Naghihintay sa restaurant",
    l31: "Hindi tinanggap ng restaurant",
    l32: "Hindi binuksan ang mesa",
    l33: "Mesa sa pagbabayad",
    l34: "Napasobra sa bilang ng order",
    l35: "Napasobra ang dami",
    l36: "Labas ng oras ng order",
    l37: "Oras ng order ay natapos",
    l38: "Sold out",
    l39: "Hindi tinanggap ng restaurant",
    l40: "Pagluluto",
    l41: "Dapat pumili",
    l42: "Min pumili",
    l43: "Max pumili",
    l44: "Pumili",
    l45: "Pag-login ng Miyembro",
    l46: "Mag-login",
    l47: "Magparehistro",
    l48: "Mangyaring ipasok ang pangalan",
    l49: "Kumuha ng verification code",
    l50: "Mangyaring ipasok ang email",
    l51: "Mangyaring ipasok ang password",
    l52: "I-logout ang kasalukuyang miyembro?",
    l53: "Mangyaring ipasok ang tamang format ng email",
    l54: "Mangyaring ipasok ang verification code",
    l55: "Matagumpay ang pagpaparehistro",
    l56: "Naipadala na ang code",
    l57: "Nabigo ang pagpapadala ng code",
    l58: "Ang email na ito ay nakarehistro na",
    l59: "Mali ang verification code",
    l60: "Nabigo ang pagpaparehistro",
    l61: "Wala ang miyembro o mali ang password",
    l62: "Walang available na kupon",
    l63: "Mangyaring mag-login muna bilang miyembro",
    l64: "I-clear",
    l65: "Pumili ng kupon",
    l66: "Pinakamataas",
    l67: "Kupon",
    l68: "Diskwento",
    l69: "Tapos na",
    l70: "Liham na elektroniko",
    l71: "Hudyat ng pagpasa",
    l72: "Ilagay ang pangalan ng gumagamit",
    l73: "Ilagay ang tirahan ng liham na elektroniko",
    l74: "Ilagay ang kode ng pagpapatunay",
    l75: "Ilagay ang hudyat ng pagpasa",
    l76: "Napili",
    l77: "Pumili",
    l78: "Matagumpay na naidagdag",
    l79: "Walang kupon ng diskwento ang magagamit ngayon",
    l80: "Ang ilang kupon ay nawalan na ng bisa at awtomatikong inalis",
    l81: "Pinakamataas na mapipili",
    l82: "kupon",
    l83: "Ang kabuuang halaga ng pagkakasunod ay hindi nakakatugon sa kondisyon ng kupon",
    l84: "Ang halaga ng diskwento ay hindi maaaring mas malaki kaysa sa kabuuang halaga ng pagkakasunod",
    l85: "Nabigong makuha ang susi ng tindahan",
    l86: "Matagumpay na nakapasok",
    l87: "Nabigong pumasok",
    l88: "Kulang ang numero ng resibo ng pagkonsumo ng kasapi",
    l89: "Nabigong itala ang pagkonsumo ng kasapi",
    l90: "Kulang ang numero ng tindahan",
    l91: "Walang laman ang susi ng tindahan",
    l92: "Nabigong suriin ang susi ng tindahan",
    l93: "Hindi sinusuportahan ng kasalukuyang tagatanaw ng pahina ang paglutas ng AES",
    l94: "Hindi pa aktibo ang tindahan",
    l95: "Ilagay ang pangalan ng gumagamit",
    l96: "Nabigong bumuo ng kawing ng pagbabayad",
    l97: "Naabot na ang pinakamataas na dami na mapipili",
    l98: "Mga pagpipilian",
    l99: "Maling halaga ng mga takda",
    l100: "Kinakailangan",
    l101: "Kupon ng diskwento",
    l102: "Magagamit pagkatapos pumasok",
    l103: "Napili",
    l104: "piraso",
    l105: "Magagamit",
    l106: "0 piraso ang magagamit",
    l107: "Hindi magagamit",
    l108: "Magagamit para sa pagkakasunod na ito",
    l109: "Pagkakasunod na lampas sa halagang",
    l110: "Magagamit",
    l111: "Kunin sa tindahan",
    l112: "Paghahatid sa tahanan",
    l113: "Pangalan",
    l114: "Telepono",
    l115: "Kodigo ng koreo",
    l116: "Tirahan",
    l117: "Oras ng pagkuha",
    l118: "Oras ng pagdating",
    l119: "Mga kinakailangang pagpipilian",
    l120: "Nakapirming hanay ng mga putahe",
    l121: "Mga opsyonal na bagay sa hanay ng mga putahe",
    l122: "Kabayaran para sa serbisyo",
    l123: "Presyo ng putahe",
    l124: "Bayad sa serbisyo",
    l125: "Bayad sa pagpapakete",
    l126: "pirasong pinakamababa",
    l127: "Lahat",
    l128: "May buwis na",
    l129: "Bago ang buwis",
    l130: "Ilagay",
    l131: "Pasadyang mga paunawa",
    l132: "Ilagay ang mga paunawa",
    l133: "Mga paunawa",
    l134: "Piliin lahat",
    l135: "Kabuuang halaga",
    l136: "Magpadala ng pagkakasunod",
    l137: "Matagumpay na nakuha->",
    l138: "Nasuri na",
    l139: "Ang pahinang ito ay nagpapakita lamang ng mga pagkaing inorder gamit ang QR code. Upang makita ang buong resibo, bumalik at pindutin ang icon sa kanang ibabang bahagi.",
  },
  {
    l1: "Pesan",
    l2: "Telepon restoran",
    l3: "Jam buka",
    l4: "Bahasa",
    l5: "Nomor meja",
    l6: "Cari",
    l7: "Kembali",
    l8: "Satuan",
    l9: "Menu paket",
    l10: "Cara memasak",
    l11: "Tambahkan ke keranjang",
    l12: "OK",
    l13: "Metode",
    l14: "Harga tambahan",
    l15: "Konfirmasi",
    l16: "Batal",
    l17: "Tips",
    l18: "Keranjang",
    l19: "Pilih semua",
    l20: "Pesan",
    l21: "Hapus?",
    l22: "Tidak ada makanan",
    l23: "Waktu makan",
    l24: "Maks",
    l25: "Konfirmasi pesanan?",
    l26: "Pilih makanan terlebih dahulu",
    l27: "Terlalu banyak makanan",
    l28: "Memproses...",
    l29: "Pesanan gagal",
    l30: "Menunggu restoran",
    l31: "Restoran tidak menerima",
    l32: "Meja tidak dibuka",
    l33: "Meja sedang bayar",
    l34: "Melebihi batas pesanan",
    l35: "Jumlah melebihi",
    l36: "Di luar jam pesanan",
    l37: "Waktu pesanan habis",
    l38: "Habis",
    l39: "Restoran tidak menerima",
    l40: "Cara memasak",
    l41: "Harus memilih",
    l42: "Min memilih",
    l43: "Max memilih",
    l44: "Silakan pilih",
    l45: "Login anggota",
    l46: "Masuk",
    l47: "Daftar",
    l48: "Silakan masukkan nama",
    l49: "Dapatkan kode verifikasi",
    l50: "Silakan masukkan email",
    l51: "Silakan masukkan sandi",
    l52: "Keluar dari anggota saat ini?",
    l53: "Silakan masukkan email yang valid",
    l54: "Silakan masukkan kode verifikasi",
    l55: "Pendaftaran berhasil",
    l56: "Kode terkirim",
    l57: "Gagal mengirim kode",
    l58: "Email sudah terdaftar",
    l59: "Kesalahan kode verifikasi",
    l60: "Pendaftaran gagal",
    l61: "Anggota tidak ada atau sandi salah",
    l62: "Tidak ada kupon tersedia",
    l63: "Silakan login anggota terlebih dahulu",
    l64: "Bersihkan",
    l65: "Pilih kupon",
    l66: "Maks pilih",
    l67: "Kupon",
    l68: "Diskon kupon",
    l69: "Selesai",
    l70: "Surel",
    l71: "Kata sandi",
    l72: "Masukkan nama pengguna",
    l73: "Masukkan alamat surel",
    l74: "Masukkan kode verifikasi",
    l75: "Masukkan kata sandi",
    l76: "Terpilih",
    l77: "Pilih",
    l78: "Berhasil ditambahkan",
    l79: "Saat ini tidak ada kupon diskon yang tersedia",
    l80: "Beberapa kupon kedaluwarsa dan telah dihapus secara otomatis",
    l81: "Maksimal yang dapat dipilih",
    l82: "kupon",
    l83: "Total pesanan belum memenuhi syarat penggunaan kupon ini",
    l84: "Jumlah diskon tidak boleh lebih besar dari total pesanan",
    l85: "Gagal mendapatkan kunci toko",
    l86: "Masuk berhasil",
    l87: "Masuk gagal",
    l88: "Nomor faktur konsumsi anggota tidak ada",
    l89: "Pencatatan konsumsi anggota gagal",
    l90: "Nomor toko tidak ada",
    l91: "Kunci toko kosong",
    l92: "Gagal mengurai kunci toko",
    l93: "Peramban ini tidak mendukung dekripsi AES",
    l94: "Toko belum diaktifkan",
    l95: "Masukkan nama pengguna",
    l96: "Gagal membuat tautan pembayaran",
    l97: "Jumlah maksimal yang dapat dipilih telah tercapai",
    l98: "Opsi",
    l99: "Kesalahan parameter",
    l100: "Wajib diisi",
    l101: "Kupon diskon",
    l102: "Tersedia setelah masuk",
    l103: "Terpilih",
    l104: "buah",
    l105: "Tersedia",
    l106: "0 buah tersedia",
    l107: "Tidak tersedia",
    l108: "Tersedia untuk pesanan ini",
    l109: "Pesanan dengan nilai lebih dari",
    l110: "Tersedia",
    l111: "Ambil sendiri",
    l112: "Pengantaran ke rumah",
    l113: "Nama lengkap",
    l114: "Nomor telepon",
    l115: "Kode pos",
    l116: "Alamat",
    l117: "Waktu pengambilan",
    l118: "Waktu tiba",
    l119: "Pilihan wajib",
    l120: "Paket menu tetap",
    l121: "Butir menu paket opsional",
    l122: "Uang tip",
    l123: "Harga hidangan",
    l124: "Biaya layanan",
    l125: "Biaya pengemasan",
    l126: "buah minimum",
    l127: "Semua",
    l128: "Termasuk pajak",
    l129: "Sebelum pajak",
    l130: "Masukkan",
    l131: "Catatan khusus",
    l132: "Masukkan catatan",
    l133: "Catatan",
    l134: "Pilih semua",
    l135: "Total bayar",
    l136: "Kirim pesanan",
    l137: "Berhasil diambil->",
    l138: "Telah diurai",
    l139: "Halaman ini hanya menampilkan hidangan yang dipesan melalui kode QR. Untuk melihat tagihan lengkap, kembali dan ketuk ikon di kanan bawah.",
  },
  {
    l1: "สั่งอาหาร",
    l2: "โทรศัพท์ร้านอาหาร",
    l3: "เวลาทำการ",
    l4: "ภาษา",
    l5: "หมายเลขโต๊ะ",
    l6: "ค้นหา",
    l7: "กลับ",
    l8: "หน่วย",
    l9: "เมนูชุด",
    l10: "วิธีทำ",
    l11: "เพิ่มลงตะกร้า",
    l12: "ตกลง",
    l13: "วิธีการ",
    l14: "ราคาเพิ่ม",
    l15: "ยืนยัน",
    l16: "ยกเลิก",
    l17: "คำแนะนำ",
    l18: "ตะกร้า",
    l19: "เลือกทั้งหมด",
    l20: "สั่งอาหาร",
    l21: "ลบ?",
    l22: "ไม่มีอาหาร",
    l23: "เวลาทาน",
    l24: "สูงสุด",
    l25: "ยืนยันการสั่ง?",
    l26: "กรุณาเลือกอาหาร",
    l27: "อาหารมากเกินไป",
    l28: "กำลังประมวล...",
    l29: "สั่งไม่สำเร็จ",
    l30: "รอสถานี",
    l31: "ร้านไม่ยอมรับ",
    l32: "โต๊ะยังไม่เปิด",
    l33: "โต๊ะกำลังเช็คบิล",
    l34: "เกินจำนวนสั่ง",
    l35: "จำนวนเกิน",
    l36: "ไม่ในช่วงเวลา",
    l37: "เวลาสั่งหมด",
    l38: "หมด",
    l39: "ร้านไม่ยอมรับ",
    l40: "วิธีทำ",
    l41: "ต้องเลือก",
    l42: "น้อยสุด",
    l43: "มากสุด",
    l44: "กรุณาเลือก",
    l45: "เข้าสู่ระบบสมาชิก",
    l46: "เข้าสู่ระบบ",
    l47: "สมัครสมาชิก",
    l48: "กรุณากรอกชื่อ",
    l49: "รับรหัสยืนยัน",
    l50: "กรุณากรอกอีเมล",
    l51: "กรุณากรอกรหัสผ่าน",
    l52: "ออกจากระบบสมาชิกปัจจุบันหรือไม่?",
    l53: "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
    l54: "กรุณากรอกรหัสยืนยัน",
    l55: "สมัครสำเร็จ",
    l56: "ส่งรหัสยืนยันแล้ว",
    l57: "ส่งรหัสยืนยันไม่สำเร็จ",
    l58: "อีเมลนี้ลงทะเบียนแล้ว",
    l59: "รหัสยืนยันผิด",
    l60: "สมัครไม่สำเร็จ",
    l61: "ไม่มีสมาชิกหรือรหัสผ่านผิด",
    l62: "ไม่มีคูปองใช้ได้",
    l63: "กรุณาเข้าสู่ระบบก่อน",
    l64: "ล้าง",
    l65: "เลือกคูปอง",
    l66: "สูงสุดเลือก",
    l67: "คูปอง",
    l68: "ส่วนลดคูปอง",
    l69: "เสร็จสิ้น",
    l70: "อีเมล",
    l71: "รหัสผ่าน",
    l72: "กรุณากรอกชื่อผู้ใช้",
    l73: "กรุณากรอกที่อยู่อีเมล",
    l74: "กรุณากรอกรหัสยืนยัน",
    l75: "กรุณากรอกรหัสผ่าน",
    l76: "เลือกแล้ว",
    l77: "เลือก",
    l78: "เพิ่มสำเร็จ",
    l79: "ไม่มีคูปองส่วนลดที่ใช้ได้ในขณะนี้",
    l80: "คูปองบางใบหมดอายุแล้ว และถูกยกเลิกโดยอัตโนมัติ",
    l81: "เลือกได้สูงสุด",
    l82: "ใบ คูปอง",
    l83: "ยอดออเดอร์ยังไม่ถึงเกณฑ์ใช้คูปองนี้",
    l84: "ส่วนลดต้องไม่มากกว่ายอดออเดอร์",
    l85: "รับคีย์ร้านค้าไม่สำเร็จ",
    l86: "เข้าสู่ระบบสำเร็จ",
    l87: "เข้าสู่ระบบไม่สำเร็จ",
    l88: "ไม่มีเลขที่ใบเสร็จสมาชิก",
    l89: "บันทึกการใช้จ่ายสมาชิกไม่สำเร็จ",
    l90: "ไม่มีรหัสร้านค้า",
    l91: "คีย์ร้านค้าเป็นค่าว่าง",
    l92: "แปลงคีย์ร้านค้าไม่สำเร็จ",
    l93: "เบราว์เซอร์นี้ไม่รองรับการถอดรหัส AES",
    l94: "ร้านยังไม่ได้เปิดใช้งาน",
    l95: "กรุณากรอกชื่อผู้ใช้",
    l96: "สร้างลิงก์ชำระเงินไม่สำเร็จ",
    l97: "ถึงจำนวนสูงสุดที่เลือกได้แล้ว",
    l98: "ตัวเลือก",
    l99: "พารามิเตอร์ผิด",
    l100: "ต้องกรอก",
    l101: "คูปองส่วนลด",
    l102: "ใช้ได้หลังเข้าสู่ระบบ",
    l103: "เลือกแล้ว",
    l104: "ชิ้น",
    l105: "ใช้ได้",
    l106: "0 ชิ้น ใช้ได้",
    l107: "ใช้ไม่ได้",
    l108: "ใช้ได้กับออเดอร์นี้",
    l109: "ออเดอร์ครบ",
    l110: "ใช้ได้",
    l111: "รับที่ร้าน",
    l112: "จัดส่งถึงบ้าน",
    l113: "ชื่อ-นามสกุล",
    l114: "เบอร์โทรศัพท์",
    l115: "รหัสไปรษณีย์",
    l116: "ที่อยู่",
    l117: "เวลารับอาหาร",
    l118: "เวลาถึง",
    l119: "ตัวเลือกที่ต้องเลือก",
    l120: "เซ็ตเมนูคงที่",
    l121: "รายการเลือกเพิ่มในเซ็ตเมนู",
    l122: "ค่าทิป",
    l123: "ราคาอาหาร",
    l124: "ค่าบริการ",
    l125: "ค่าบรรจุภัณฑ์",
    l126: "ชิ้นขั้นต่ำ",
    l127: "ทั้งหมด",
    l128: "รวมภาษี",
    l129: "ก่อนภาษี",
    l130: "กรุณากรอก",
    l131: "หมายเหตุส่วนตัว",
    l132: "กรุณากรอกหมายเหตุ",
    l133: "หมายเหตุ",
    l134: "เลือกทั้งหมด",
    l135: "รวมทั้งสิ้น",
    l136: "ยืนยันออเดอร์",
    l137: "รับสำเร็จ->",
    l138: "แปลงแล้ว",
    l139: "หน้านี้แสดงเฉพาะรายการอาหารที่สั่งผ่านคิวอาร์โค้ด หากต้องการดูใบเสร็จเต็ม กรุณากลับไปแตะไอคอนที่มุมขวาล่าง",
  },
  {
    l1: "Προσφορά",
    l2: "Τηλέφωνο εστιατορίου",
    l3: "Ώρες λειτουργίας",
    l4: "Γλώσσα",
    l5: "Αριθμός τραπεζιού",
    l6: "Αναζήτηση",
    l7: "Επιστροφή",
    l8: "Μονάδα",
    l9: "Μενού",
    l10: "Κατασκευή",
    l11: "Προσθήκη στο καλάθι",
    l12: "OK",
    l13: "Μέθοδος",
    l14: "Επιπλέον τιμή",
    l15: "Επιβεβαίωση",
    l16: "Άκυρο",
    l17: "Υπόμνημα",
    l18: "Καλάθι",
    l19: "Επιλογή όλων",
    l20: "Προσφορά",
    l21: "Διαγραφή?",
    l22: "Δεν υπάρχει φαγητό",
    l23: "Ώρα φαγητού",
    l24: "Μέγιστο",
    l25: "Επιβεβαιώσετε την παραγγελία;",
    l26: "Επιλέξτε πιάτα πρώτα",
    l27: "Πολύ πολλά πιάτα",
    l28: "Επεξεργασία...",
    l29: "Η παραγγελία απέτυχε",
    l30: "Αναμονή εστιατορίου",
    l31: "Το εστιατόριο δεν αποδέχεται",
    l32: "Ο τραπεζάκι δεν είναι ανοικτό",
    l33: "Τραπεζάκι σε εξόφληση",
    l34: "Υπερέβη το όριο παραγγελιών",
    l35: "Η ποσότητα υπερβεί",
    l36: "Εκτός ωρών παραγγελιών",
    l37: "Η ώρα παραγγελίας έληξε",
    l38: "Εξαντλημένο",
    l39: "Το εστιατόριο δεν αποδέχεται",
    l40: "Κατασκευή",
    l41: "Πρέπει να επιλέξετε",
    l42: "Ελάχιστο",
    l43: "Μέγιστο",
    l44: "Επιλέξτε",
    l45: "Σύνδεση μέλους",
    l46: "Σύνδεση",
    l47: "Εγγραφή",
    l48: "Παρακαλώ εισάγετε όνομα",
    l49: "Λήψη κωδικού επαλήθευσης",
    l50: "Παρακαλώ εισάγετε email",
    l51: "Παρακαλώ εισάγετε κωδικό",
    l52: "Αποσύνδεση τρέχοντος μέλους;",
    l53: "Παρακαλώ εισάγετε έγκυρο email",
    l54: "Παρακαλώ εισάγετε κωδικό επαλήθευσης",
    l55: "Επιτυχής εγγραφή",
    l56: "Κωδικός εστάλη",
    l57: "Αποτυχία αποστολής κωδικού",
    l58: "Το email έχει ήδη εγγραφεί",
    l59: "Σφάλμα κωδικού επαλήθευσης",
    l60: "Αποτυχημένη εγγραφή",
    l61: "Το μέλος δεν υπάρχει ή λάθος κωδικός",
    l62: "Δεν υπάρχουν διαθέσιμα κουπόνια",
    l63: "Παρακαλώ συνδεθείτε πρώτα",
    l64: "Εκκαθάριση",
    l65: "Επιλογή κουπονιού",
    l66: "Μέγιστη επιλογή",
    l67: "Κουπόνι",
    l68: "Έκπτωση κουπονιού",
    l69: "Ολοκληρώθηκε",
    l70: "Ηλεκτρονικό ταχυδρομείο",
    l71: "Κωδικός πρόσβασης",
    l72: "Εισάγετε το όνομα χρήστη",
    l73: "Εισάγετε τη διεύθυνση ηλεκτρονικού ταχυδρομείου",
    l74: "Εισάγετε τον κωδικό επαλήθευσης",
    l75: "Εισάγετε τον κωδικό πρόσβασης",
    l76: "Επιλεγμένο",
    l77: "Επιλέξτε",
    l78: "Προστέθηκε με επιτυχία",
    l79: "Δεν υπάρχουν διαθέσιμα κουπόνια έκπτωσης αυτή τη στιγμή",
    l80: "Μερικά κουπόνια λήξαν και αφαιρέθηκαν αυτόματα",
    l81: "Μέγιστα για επιλογή",
    l82: "κουπόνι(α)",
    l83: "Το συνολικό ποσό της παραγγελίας δεν ικανοποιεί την προϋπόθεση του κουπονιού",
    l84: "Το ποσό έκπτωσης δεν μπορεί να υπερβαίνει το συνολικό ποσό της παραγγελίας",
    l85: "Απέτυχε η λήψη του κλειδιού του καταστήματος",
    l86: "Επιτυχής σύνδεση",
    l87: "Αποτυχία σύνδεσης",
    l88: "Λείπει ο αριθμός τιμολογίου κατανάλωσης μέλους",
    l89: "Απέτυχε η καταγραφή κατανάλωσης μέλους",
    l90: "Λείπει ο αριθμός καταστήματος",
    l91: "Το κλειδί του καταστήματος είναι κενό",
    l92: "Απέτυχε η ανάλυση του κλειδιού του καταστήματος",
    l93: "Αυτός ο περιηγητής δεν υποστηρίζει αποκρυπτογράφηση AES",
    l94: "Το κατάστημα δεν έχει ενεργοποιηθεί",
    l95: "Εισάγετε το όνομα χρήστη",
    l96: "Απέτυχε η δημιουργία συνδέσμου πληρωμής",
    l97: "Επιτεύχθηκε ο μέγιστος επιλέξιμος αριθμός",
    l98: "Επιλογές",
    l99: "Σφάλμα παραμέτρου",
    l100: "Απαιτούμενο πεδίο",
    l101: "Κουπόνι έκπτωσης",
    l102: "Διαθέσιμο μετά τη σύνδεση",
    l103: "Επιλεγμένο",
    l104: "τεμ.",
    l105: "Διαθέσιμο",
    l106: "0 τεμ. διαθέσιμα",
    l107: "Μη διαθέσιμο",
    l108: "Διαθέσιμο για αυτή την παραγγελία",
    l109: "Για παραγγελία άνω των",
    l110: "Διαθέσιμο",
    l111: "Παραλαβή από το κατάστημα",
    l112: "Παράδοση στο σπίτι",
    l113: "Πλήρες όνομα",
    l114: "Αριθμός τηλεφώνου",
    l115: "Ταχυδρομικός κώδικας",
    l116: "Διεύθυνση",
    l117: "Ώρα παραλαβής",
    l118: "Ώρα άφιξης",
    l119: "Απαιτούμενες επιλογές",
    l120: "Σταθερό σετ μενού",
    l121: "Προαιρετικές εγγραφές σετ μενού",
    l122: "Φιλοδώρημα",
    l123: "Τιμή πιάτου",
    l124: "Προμήθεια εξυπηρέτησης",
    l125: "Προμήθεια συσκευασίας",
    l126: "τεμ. ελάχιστο",
    l127: "Όλα",
    l128: "Με φόρο",
    l129: "Πριν τον φόρο",
    l130: "Εισάγετε",
    l131: "Προσαρμοσμένες σημειώσεις",
    l132: "Εισάγετε τις σημειώσεις",
    l133: "Σημειώσεις",
    l134: "Επιλογή όλων",
    l135: "Συνολικό ποσό",
    l136: "Υποβολή παραγγελίας",
    l137: "Επιτυχώς αποκτήθηκε->",
    l138: "Αναλύθηκε",
    l139: "Αυτή η σελίδα εμφανίζει μόνο τα πιάτα που παραγγέλθηκαν με κωδικό QR. Για να δείτε τον πλήρη λογαριασμό, επιστρέψτε και πατήστε το εικονίδιο κάτω δεξιά.",
  },
  {
    l1: "Naročilo",
    l2: "Telefon restavracije",
    l3: "Delovni čas",
    l4: "Jezik",
    l5: "Številka mize",
    l6: "Iskalnik",
    l7: "Nazaj",
    l8: "Enota",
    l9: "Men",
    l10: "Priprava",
    l11: "Dodaj v košarico",
    l12: "V redu",
    l13: "Metoda",
    l14: "Dodaten cena",
    l15: "Potrdi",
    l16: "Prekliči",
    l17: "Namig",
    l18: "Košarica",
    l19: "Izberi vse",
    l20: "Naroči",
    l21: "Izbriši?",
    l22: "Ni hrane",
    l23: "Čas jedi",
    l24: "Maksimum",
    l25: "Potrdite naročilo?",
    l26: "Izberite jedi najprej",
    l27: "Preveč jedi",
    l28: "Obdelava...",
    l29: "Naročilo ni uspelo",
    l30: "Čakanje na restavracijo",
    l31: "Restavracija ni sprejela",
    l32: "Miza ni odprta",
    l33: "Miza v plačevanju",
    l34: "Presegli ste omejitev",
    l35: "Količina presežena",
    l36: "Zunaj časovnega obdobja",
    l37: "Čas naročila potekel",
    l38: "Zakoščeno",
    l39: "Restavracija ni sprejela",
    l40: "Priprava",
    l41: "Moraš izbrati",
    l42: "Min izbrati",
    l43: "Max izbrati",
    l44: "Izberite",
    l45: "Prijava člana",
    l46: "Prijava",
    l47: "Registracija",
    l48: "Vnesite ime",
    l49: "Pridobi kodo za preverjanje",
    l50: "Vnesite e-pošto",
    l51: "Vnesite geslo",
    l52: "Odjaviti trenutnega člana?",
    l53: "Vnesite veljavno e-pošto",
    l54: "Vnesite kodo za preverjanje",
    l55: "Registracija uspešna",
    l56: "Koda poslana",
    l57: "Pošiljanje kode ni uspelo",
    l58: "E-pošta že registrirana",
    l59: "Napačna koda za preverjanje",
    l60: "Registracija ni uspela",
    l61: "Član ne obstaja ali napačno geslo",
    l62: "Ni na voljo kuponov",
    l63: "Najprej se prijavite kot član",
    l64: "Počisti",
    l65: "Izberi kupon",
    l66: "Največ",
    l67: "Kupon",
    l68: "Popust",
    l69: "Končano",
    l70: "E‑pošta",
    l71: "Geslo",
    l72: "Vnesite uporabniško ime",
    l73: "Vnesite e‑poštni naslov",
    l74: "Vnesite kodo za preverjanje",
    l75: "Vnesite geslo",
    l76: "Izbrano",
    l77: "Izberi",
    l78: "Uspešno dodano",
    l79: "Trenutno ni na voljo nobenih kuponov za popust",
    l80: "Nekateri kuponi so potekli in so bili samodejno odstranjeni",
    l81: "Največ za izbiro",
    l82: "kupon(ov)",
    l83: "Skupni znesek naročila ne ustreza pogoju za uporabo kupona",
    l84: "Znesek popusta ne sme biti večji od skupnega zneska naročila",
    l85: "Pridobivanje ključa trgovine ni uspelo",
    l86: "Prijava je uspela",
    l87: "Prijava ni uspela",
    l88: "Manjka številka računa porabe članstva",
    l89: "Zapis porabe članstva ni uspel",
    l90: "Manjka številka trgovine",
    l91: "Ključ trgovine je prazen",
    l92: "Razčlenitev ključa trgovine ni uspela",
    l93: "Ta brskalnik ne podpira AES dešifriranja",
    l94: "Trgovina ni aktivirana",
    l95: "Vnesite uporabniško ime",
    l96: "Ustvarjanje povezave za plačilo ni uspelo",
    l97: "Doseženo je največje število izbirnih enot",
    l98: "Možnosti",
    l99: "Napaka parametra",
    l100: "Obvezno polje",
    l101: "Kupon za popust",
    l102: "Na voljo po prijavi",
    l103: "Izbrano",
    l104: "kos(ov)",
    l105: "Na voljo",
    l106: "0 kosov na voljo",
    l107: "Ni na voljo",
    l108: "Na voljo za to naročilo",
    l109: "Pri naročilu nad zneskom",
    l110: "Na voljo",
    l111: "Osebni prevzem",
    l112: "Dostava domov",
    l113: "Polno ime",
    l114: "Telefonska številka",
    l115: "Poštna številka",
    l116: "Naslov",
    l117: "Čas prevzema",
    l118: "Čas prihoda",
    l119: "Obvezne izbire",
    l120: "Fiksni meni",
    l121: "Izbirne postavke menija",
    l122: "Napitnina",
    l123: "Cena jedi",
    l124: "Storitev",
    l125: "Pakiranje",
    l126: "kosov minimum",
    l127: "Vse",
    l128: "Z davkom",
    l129: "Pred davkom",
    l130: "Vnesite",
    l131: "Prilagojene opombe",
    l132: "Vnesite opombe",
    l133: "Opombe",
    l134: "Izberi vse",
    l135: "Skupni znesek",
    l136: "Pošlji naročilo",
    l137: "Uspešno pridobljeno->",
    l138: "Razčlenjeno",
    l139: "Ta stran prikazuje samo jedi naročene s QR kodo. Če želite videti celoten račun, vrnite se in kliknite ikono v spodnjem desnem kotu.",
  },
  {
    l1: "Order",
    l2: "Restaurant Phone",
    l3: "Business Hours",
    l4: "Language",
    l5: "Table No.",
    l6: "Search",
    l7: "Back",
    l8: "Unit",
    l9: "Set Meal",
    l10: "Preparation",
    l11: "Add to Cart",
    l12: "OK",
    l13: "Method",
    l14: "Extra Price",
    l15: "Confirm",
    l16: "Cancel",
    l17: "Tips",
    l18: "Cart",
    l19: "Select All",
    l20: "Order",
    l21: "Delete?",
    l22: "No Food",
    l23: "Dining Time",
    l24: "Max",
    l25: "Confirm order?",
    l26: "Please select dishes first",
    l27: "Too many dishes",
    l28: "Ordering...",
    l29: "Order failed",
    l30: "Waiting for restaurant",
    l31: "Restaurant not accepted",
    l32: "Table not opened",
    l33: "Table is checking out",
    l34: "Exceeded max order count",
    l35: "Order quantity exceeded",
    l36: "Outside ordering hours",
    l37: "Order time expired, reopen table",
    l38: "Sold out",
    l39: "Restaurant not accepted",
    l40: "Preparation",
    l41: "Must select",
    l42: "Min select",
    l43: "Max select",
    l44: "Please select",
    l45: "Member Login",
    l46: "Login",
    l47: "Register",
    l48: "Please enter name",
    l49: "Get verification code",
    l50: "Please enter email",
    l51: "Please enter password",
    l52: "Log out current member?",
    l53: "Please enter valid email",
    l54: "Please enter verification code",
    l55: "Registration successful",
    l56: "Verification code sent",
    l57: "Failed to send code",
    l58: "Email already registered",
    l59: "Verification code error",
    l60: "Registration failed",
    l61: "Member not found or wrong password",
    l62: "No available coupons",
    l63: "Please login member first",
    l64: "Clear",
    l65: "Select coupon",
    l66: "Max select",
    l67: "Coupon",
    l68: "Coupon discount",
    l69: "Done",
    l70: "Email",
    l71: "Password",
    l72: "Enter your name",
    l73: "Enter email address",
    l74: "Enter verification code",
    l75: "Enter password",
    l76: "Selected",
    l77: "Select",
    l78: "Added successfully",
    l79: "No coupons available",
    l80: "Some coupons expired and have been removed",
    l81: "Max. selectable",
    l82: "coupon(s)",
    l83: "Order total does not meet coupon requirement",
    l84: "Discount cannot exceed order total",
    l85: "Failed to get store key",
    l86: "Login successful",
    l87: "Login failed",
    l88: "Member consume order number missing",
    l89: "Member consume record failed",
    l90: "Store number missing",
    l91: "Store key is empty",
    l92: "Store key parse failed",
    l93: "AES decrypt not supported in current browser",
    l94: "Store not activated",
    l95: "Please enter your name",
    l96: "Payment link generation failed",
    l97: "Max. selectable quantity reached",
    l98: "Options",
    l99: "Parameter error",
    l100: "Required",
    l101: "Coupon",
    l102: "Available after login",
    l103: "Selected",
    l104: "item(s)",
    l105: "Available",
    l106: "0 item(s) available",
    l107: "Not available",
    l108: "Available for this order",
    l109: "Order over",
    l110: "Available",
    l111: "Self Pickup",
    l112: "Delivery",
    l113: "Name",
    l114: "Phone",
    l115: "Postcode",
    l116: "Address",
    l117: "Pickup Time",
    l118: "Arrival Time",
    l119: "Required selections",
    l120: "Fixed set meal",
    l121: "Optional set meal items",
    l122: "Tip",
    l123: "Dish Price",
    l124: "Service Fee",
    l125: "Packing Fee",
    l126: "pcs minimum",
    l127: "All",
    l128: "Tax included",
    l129: "Before tax",
    l130: "Please enter",
    l131: "Custom remarks",
    l132: "Please enter remarks",
    l133: "Remarks",
    l134: "Select All",
    l135: "Total",
    l136: "Order",
    l137: "Got success->",
    l138: "Parsed",
    l139: "This page only shows items ordered via QR code. To view the full bill, return and click the icon at the bottom right.",
  },
  {
    l1: "Sifariş",
    l2: "Restoran telefonu",
    l3: "İş saatləri",
    l4: "Dil",
    l5: "Masa nömrəsi",
    l6: "Axtar",
    l7: "Geri",
    l8: "Vahid",
    l9: "Menu",
    l10: "Hazırlama",
    l11: "Səbətə əlavə et",
    l12: "Tamam",
    l13: "Metod",
    l14: "Əlavə qiymət",
    l15: "Təsdiqlə",
    l16: "Ləğv et",
    l17: "İpucu",
    l18: "Səbət",
    l19: "Hamısını seç",
    l20: "Sifariş",
    l21: "Sil?",
    l22: "Məhsul yoxdur",
    l23: "Yemək vaxtı",
    l24: "Maksimum",
    l25: "Sifarişi təsdiqləyin?",
    l26: "Öncə yeməkləri seçin",
    l27: "Çox çox yemək",
    l28: "İşlənir...",
    l29: "Sifariş uğursuz oldu",
    l30: "Restoranın gözləməsi",
    l31: "Restoran qəbul etməyib",
    l32: "Masa açılmayıb",
    l33: "Masa ödənişdə",
    l34: "Maksimum sifarişi keçdi",
    l35: "Miqdarı keçdi",
    l36: "Sifariş saatlarından kənarda",
    l37: "Sifariş vaxtı bitdi",
    l38: "Bitib",
    l39: "Restoran qəbul etməyib",
    l40: "Hazırlama",
    l41: "Seçməlisiniz",
    l42: "Min seç",
    l43: "Max seç",
    l44: "Zəhmət olmasa seçin",
    l45: "Üzv Girişi",
    l46: "Giriş",
    l47: "Qeydiyyat",
    l48: "Zəhmət olmasa adı daxil edin",
    l49: "Doğrulama kodunu alın",
    l50: "Zəhmət olmasa e-poçtu daxil edin",
    l51: "Zəhmət olmasa parolu daxil edin",
    l52: "Cari üzvlüyü çıxarmaq?",
    l53: "Düzgün e-poçt formatını daxil edin",
    l54: "Doğrulama kodunu daxil edin",
    l55: "Qeydiyyat uğurlu oldu",
    l56: "Kod göndərildi",
    l57: "Kod göndərilmədi",
    l58: "Bu e-poçt artıq qeydiyyatdan keçib",
    l59: "Doğrulama kodu səhvdir",
    l60: "Qeydiyyat uğursuz oldu",
    l61: "Üzv tapılmadı və ya parol səhvdir",
    l62: "Mövcud kupon yoxdur",
    l63: "Əvvəlcə üzv olaraq giriş edin",
    l64: "Təmizlə",
    l65: "Kupon seç",
    l66: "Maksimum",
    l67: "Kupon",
    l68: "Gətiri",
    l69: "Hazır",
    l70: "E‑poçt",
    l71: "Şifrə",
    l72: "İstifadəçi adını daxil edin",
    l73: "E‑poçt ünvanını daxil edin",
    l74: "Təsdiqləmə kodunu daxil edin",
    l75: "Şifrəni daxil edin",
    l76: "Seçildi",
    l77: "Seçin",
    l78: "Uğurla əlavə edildi",
    l79: "Hazırda mövcud endirim kuponu yoxdur",
    l80: "Bəzi kuponların müddəti bitib və avtomatik silinib",
    l81: "Maksimum seçilə bilən",
    l82: "kupon",
    l83: "Sifarişin ümumi məbləği kupon şərtini ödəmir",
    l84: "Endirim məbləği sifarişin ümumi məbləğindən böyük ola bilməz",
    l85: "Mağaza açarı alınmadı",
    l86: "Giriş uğurlu oldu",
    l87: "Giriş uğursuz oldu",
    l88: "Üzvlük istehlak faktura nömrəsi çatışmır",
    l89: "Üzvlük istehlak qeydi alınmadı",
    l90: "Mağaza nömrəsi çatışmır",
    l91: "Mağaza açarı boşdur",
    l92: "Mağaza açarı deşifrə edilmədi",
    l93: "Bu brauzer AES deşifrə etməsini dəstəkləmir",
    l94: "Mağaza aktivləşdirilməyib",
    l95: "İstifadəçi adını daxil edin",
    l96: "Ödəniş linki yaradılmadı",
    l97: "Maksimum seçilə bilən miqdara çatıb",
    l98: "Seçimlər",
    l99: "Parametr səhvi",
    l100: "Vacib sahə",
    l101: "Endirim kuponu",
    l102: "Girişdən sonra mövcuddur",
    l103: "Seçildi",
    l104: "ədəd",
    l105: "Mövcuddur",
    l106: "0 ədəd mövcuddur",
    l107: "Mövcud deyil",
    l108: "Bu sifariş üçün mövcuddur",
    l109: "Sifariş məbləği yuxarıda",
    l110: "Mövcuddur",
    l111: "Özün götür",
    l112: "Evə çatdırılma",
    l113: "Tam ad",
    l114: "Telefon nömrəsi",
    l115: "Poçt indeksi",
    l116: "Ünvan",
    l117: "Götürmə vaxtı",
    l118: "Gəlmə vaxtı",
    l119: "Vacib seçimlər",
    l120: "Sabit menü",
    l121: "İstəyə bağlı menü elementləri",
    l122: "Hədiyyə pulu",
    l123: "Yemək qiyməti",
    l124: "Xidmət haqqı",
    l125: "Qablaşdırma haqqı",
    l126: "minimum ədəd",
    l127: "Hamısı",
    l128: "Vergi daxil",
    l129: "Vergidən əvvəl",
    l130: "Daxil edin",
    l131: "Fərdi qeydlər",
    l132: "Qeydləri daxil edin",
    l133: "Qeydlər",
    l134: "Hamısını seç",
    l135: "Ümumi məbləğ",
    l136: "Sifariş ver",
    l137: "Uğurla alındı->",
    l138: "Deşifrə edildi",
    l139: "Bu səhifədə yalnız QR kodu ilə sifariş verilən yeməklər göstərilir. Tam hesabı görmək üçün geri qayıdın və sağ alt tərəfdakı nişana tıklayın.",
  },
  {
    l1: "အမှာစာ",
    l2: "အစားအစာဘုရားရုံးဖုန်း",
    l3: "လည်ပတ်နေချိန်",
    l4: "ဘာသာစကား",
    l5: "စားပွဲနံပါတ်",
    l6: "ရှာဖွေ",
    l7: "ပြန်သွား",
    l8: "ယူနစ်",
    l9: "မီနူး",
    l10: "ပြင်ဆင်ခြင်း",
    l11: "ကားတွင်းထဲသို့ထည့်",
    l12: "သိတယ်",
    l13: "နည်းလမ်း",
    l14: "အပိုကုန်ကျ",
    l15: "အတည်ပြု",
    l16: "ရပ်လိုက်",
    l17: "သတိပေး",
    l18: "ကားတွင်း",
    l19: "အားလုံးကိုရွေး",
    l20: "အမှာစာ",
    l21: "ဖျက်ရန်?",
    l22: "အစားအစာမရှိ",
    l23: "စားသောက်နေချိန်",
    l24: "အများဆုံး",
    l25: "အမှာစာကိုအတည်ပြု?",
    l26: "အစားအစာကိုရွေးပါ",
    l27: "အစားအစာများလွန်း",
    l28: "လုပ်နေပါသည်...",
    l29: "အမှာစာအမအောင်",
    l30: "အစားအစာဘုရားရုံးကိုစောင့်",
    l31: "အစားအစာဘုရားရုံးကမလက်ခံ",
    l32: "စားပွဲမဖွင့်",
    l33: "စားပွဲငွေပေးချေနေစဉ်",
    l34: "အမှာစာအရေအတွက်ကိုကျော်",
    l35: "အရေအတွက်ကျော်",
    l36: "အမှာစာအချိန်ပြင်ပ",
    l37: "အမှာစာအချိန်ပြီး",
    l38: "ပြီး",
    l39: "အစားအစာဘုရားရုံးကမလက်ခံ",
    l40: "ပြင်ဆင်ခြင်း",
    l41: "ရွေးချယ်ရမည်",
    l42: "အနည်းဆုံး",
    l43: "အများဆုံး",
    l44: "ရွေးပါ",
    l45: "အသင်းဝင်အကောင့်ဝင်ခြင်း",
    l46: "အကောင့်ဝင်ခြင်း",
    l47: "အသစ်စာရင်းသွင်းခြင်း",
    l48: "နာမည်ကိုထည့်ပါ",
    l49: "အတည်ပြုကုဒ်ရယူပါ",
    l50: "အီးမေးလ်ထည့်ပါ",
    l51: "စကားဝှက်ထည့်ပါ",
    l52: "လက်ရှိအသင်းဝင်မှထွက်မလား?",
    l53: "မှန်ကန်သောအီးမေးလ်ပုံစံထည့်ပါ",
    l54: "အတည်ပြုကုဒ်ထည့်ပါ",
    l55: "စာရင်းသွင်းခြင်းအောင်မြင်ပါသည်",
    l56: "ကုဒ်ပေးပို့ပြီးပါပြီ",
    l57: "ကုဒ်ပေးပို့ခြင်းမအောင်မြင်ပါ",
    l58: "ဤအီးမေးလ်သည်စာရင်းပေးသွင်းပြီးသားဖြစ်သည်",
    l59: "အတည်ပြုကုဒ်မှားယွင်းနေသည်",
    l60: "စာရင်းသွင်းခြင်းမအောင်မြင်ပါ",
    l61: "အသင်းဝင်မရှိသို့မဟုတ်စကားဝှက်မှားသည်",
    l62: "အသုံးပြုနိုင်သောကူပွန်မရှိပါ",
    l63: "အရင်အသင်းဝင်အကောင့်ဝင်ပါ",
    l64: "ရှင်းလင်းရန်",
    l65: "ကူပွန်ရွေးချယ်ပါ",
    l66: "အများဆုံးရွေးချယ်နိုင်သည်",
    l67: "ကူပွန်",
    l68: "လျှော့စျေး",
    l69: "ပြီးဆုံးပါပြီ",
    l70: "အီးမေးလ်",
    l71: "စကားဝှက်",
    l72: "အသုံးပြုသူအမည်ကို ထည့်သွင်းပါ",
    l73: "အီးမေးလ်လိပ်စာကို ထည့်သွင်းပါ",
    l74: "စစ်ဆေးရေးကုဒ်ကို ထည့်သွင်းပါ",
    l75: "စကားဝှက်ကို ထည့်သွင်းပါ",
    l76: "ရွေးချယ်ပြီးပြီ",
    l77: "ရွေးချယ်ပါ",
    l78: "အောင်မြင်စွာ ပေါင်းထည့်ပြီးပါပြီ",
    l79: "လက်ရှိတွင် အသုံးပြုနိုင်သည့် လျှော့စျေးကူပွန်များ မရှိသေးပါ",
    l80: "အချို့ကူပွန်များ သက်တမ်းကုန်ဆုံးပြီး အလိုအလျောက် ဖျက်ပြီးပါပြီ",
    l81: "အများဆုံး ရွေးချယ်နိုင်သည့်အရေအတွက်",
    l82: "ကူပွန်",
    l83: "ပွဲစားရငွေစုစုပေါင်းသည် ဤကူပွန်အသုံးပြုခြင်းစည်းကမ်းနှင့် မကိုက်ညီသေးပါ",
    l84: "လျှော့ဈေးပမာဏသည် ပွဲစားရငွေထက် ကြီးလွန်းမည် မဟုတ်ပါ",
    l85: "ဆိုင်သော့ကို ရယူခြင်း မအောင်မြင်ပါ",
    l86: "အကောင့်ဝင်ခြင်း အောင်မြင်ပါတယ်",
    l87: "အကောင့်ဝင်ခြင်း မအောင်မြင်ပါ",
    l88: "အဖွဲ့ဝင်သုံးစွဲမှုငွေတောင်းခံ နံပါတ် ပျောက်ဆုံးနေပါတယ်",
    l89: "အဖွဲ့ဝင်သုံးစွဲမှုမှတ်တမ်း သိမ်းဆည်းခြင်း မအောင်မြင်ပါ",
    l90: "ဆိုင်နံပါတ် ပျောက်ဆုံးနေပါတယ်",
    l91: "ဆိုင်သော့သည် အလွတ်ဖြစ်နေပါတယ်",
    l92: "ဆိုင်သော့ကို ဖော်ထုတ်ခြင်း မအောင်မြင်ပါ",
    l93: "လက်ရှိ ဝဘ်ဘရောက်ဇာသည် AES ဖော်ထုတ်ခြင်းကို မထောက်ပံ့ပါ",
    l94: "ဆိုင်အသုံးပြုခွင့် မပေးထားသေးပါ",
    l95: "အသုံးပြုသူအမည်ကို ထည့်သွင်းပေးပါ",
    l96: "ငွေပေးချေရန် ချိတ်ဆက်မှု ဖန်တီးခြင်း မအောင်မြင်ပါ",
    l97: "ရွေးချယ်နိုင်သည့် အများဆုံးအရေအတွက်သို့ ရောက်ရှိသွားပါပြီ",
    l98: "ရွေးချယ်စရာများ",
    l99: "ကိန်းရှင် မှားယွင်းနေပါတယ်",
    l100: "မဖြစ်မနေ ထည့်သွင်းရန်",
    l101: "လျှော့စျေးကူပွန်",
    l102: "အကောင့်ဝင်ပြီးမှသာ အသုံးပြုနိုင်ပါတယ်",
    l103: "ရွေးချယ်ပြီးပြီ",
    l104: "ခု",
    l105: "အသုံးပြုနိုင်ပါတယ်",
    l106: "0 ခု အသုံးပြုနိုင်ပါတယ်",
    l107: "အသုံးပြု၍မရပါ",
    l108: "ဤပွဲစားအတွက် အသုံးပြုနိုင်ပါတယ်",
    l109: "ပွဲစားရငွေကျော်လွန်ချိန်",
    l110: "အသုံးပြုနိုင်ပါတယ်",
    l111: "ကိုယ်တိုင်ယူဆောင်",
    l112: "အိမ်ပေးပို့ခြင်း",
    l113: "အမည်",
    l114: "ဖုန်းနံပါတ်",
    l115: "စာတိုက်ကုဒ်",
    l116: "လိပ်စာ",
    l117: "အစားအစာယူရန် အချိန်",
    l118: "ရောက်ရှိမည့်အချိန်",
    l119: "မဖြစ်မနေ ရွေးချယ်ရန်",
    l120: "ပုံသေ မီနူးအစုံ",
    l121: "ရွေးချယ်နိုင်သည့် မီနူးအစုံပစ္စည်းများ",
    l122: "လက်ဆောင်ငွေ",
    l123: "ဟင်းအစားစျေးနှုန်း",
    l124: "ဝန်ဆောင်မှုအခကြေးငွေ",
    l125: "ထုပ်ပိုးခြင်းအခကြေးငွေ",
    l126: "အနည်းဆုံး အရေအတွက်",
    l127: "အားလုံး",
    l128: "အခွန်ပါဝင်ပြီး",
    l129: "အခွန်မကြာသေးမီ",
    l130: "ထည့်သွင်းပေးပါ",
    l131: "ကိုယ်ပိုင်မှတ်ချက်",
    l132: "မှတ်ချက်ကို ထည့်သွင်းပါ",
    l133: "မှတ်ချက်",
    l134: "အားလုံးကို ရွေးချယ်ပါ",
    l135: "စုစုပေါင်း",
    l136: "ပွဲစားပို့ရန်",
    l137: "အောင်မြင်စွာ ရရှိပါတယ်->",
    l138: "ဖော်ထုတ်ပြီးပါပြီ",
    l139: "ဤစာမျက်နှာတွင် QR ကုဒ်ဖြင့်မှာယူသောအစားအစာများကိုသာဖော်ပြသည်။ ပြည့်စုံသောငွေတောင်းခံလွှာကိုကြည့်ရန်၊ ပြန်သွားပြီးညာဘက်အောက်ထောင့်ရှိအိုင်ကွန်ကိုနှိပ်ပါ။",
  },
  {
    l1: "Sipariş",
    l2: "Restoran telefonu",
    l3: "İş saatleri",
    l4: "Dil",
    l5: "Masa numarası",
    l6: "Ara",
    l7: "Geri",
    l8: "Birim",
    l9: "Menu",
    l10: "Hazırlama",
    l11: "Sepete ekle",
    l12: "Tamam",
    l13: "Yöntem",
    l14: "Ekstra fiyat",
    l15: "Onayla",
    l16: "İptal",
    l17: "İpucu",
    l18: "Sepet",
    l19: "Tümünü seç",
    l20: "Sipariş",
    l21: "Sil?",
    l22: "Yemek yok",
    l23: "Yemek saati",
    l24: "Maksimum",
    l25: "Siparişi onayla?",
    l26: "Önce yemek seçin",
    l27: "Çok fazla yemek",
    l28: "İşleniyor...",
    l29: "Sipariş başarısız",
    l30: "Restoran bekliyor",
    l31: "Restoran kabul etmedi",
    l32: "Masa açılmadı",
    l33: "Masa ödeme aşamasında",
    l34: "Maksimum siparişi aştı",
    l35: "Miktar aşıldı",
    l36: "Sipariş saatleri dışında",
    l37: "Sipariş zamanı doldu",
    l38: "Tükendi",
    l39: "Restoran kabul etmedi",
    l40: "Hazırlama",
    l41: "Seçmelisiniz",
    l42: "Min seç",
    l43: "Max seç",
    l44: "Lütfen seçin",
    l45: "Üye girişi",
    l46: "Giriş",
    l47: "Kayıt ol",
    l48: "Lütfen isim girin",
    l49: "Doğrulama kodu al",
    l50: "Lütfen e-posta girin",
    l51: "Lütfen şifre girin",
    l52: "Mevcut üye oturumu kapatılsın mı?",
    l53: "Lütfen geçerli bir e-posta girin",
    l54: "Lütfen doğrulama kodunu girin",
    l55: "Kayıt başarılı",
    l56: "Kod gönderildi",
    l57: "Kod gönderilemedi",
    l58: "E-posta zaten kayıtlı",
    l59: "Doğrulama kodu hatası",
    l60: "Kayıt başarısız",
    l61: "Üye bulunamadı veya şifre yanlış",
    l62: "Kullanılabilir kupon yok",
    l63: "Önce üye girişi yapın",
    l64: "Temizle",
    l65: "Kupon seç",
    l66: "Maks seçim",
    l67: "Kupon",
    l68: "Kupon indirimi",
    l69: "Tamamlandı",
    l70: "E‑posta",
    l71: "Şifre",
    l72: "Kullanıcı adını girin",
    l73: "E‑posta adresini girin",
    l74: "Doğrulama kodunu girin",
    l75: "Şifrenizi girin",
    l76: "Seçildi",
    l77: "Seç",
    l78: "Başarıyla eklendi",
    l79: "Şu anda kullanılabilir indirim kuponu yok",
    l80: "Bazı kuponlar süresi doldu ve otomatik olarak kaldırıldı",
    l81: "En fazla seçilebilir",
    l82: "kupon",
    l83: "Sipariş toplamı kupon koşulunu karşılamıyor",
    l84: "İndirim tutarı sipariş toplamından büyük olamaz",
    l85: "Mağaza anahtarı alınamadı",
    l86: "Giriş başarılı",
    l87: "Giriş başarısız",
    l88: "Üye tüketim fatura numarası eksik",
    l89: "Üye tüketim kaydı başarısız",
    l90: "Mağaza numarası eksik",
    l91: "Mağaza anahtarı boş",
    l92: "Mağaza anahtarı analiz edilemedi",
    l93: "Bu tarayıcı AES şifre çözmeyi desteklemiyor",
    l94: "Mağaza etkinleştirilmedi",
    l95: "Kullanıcı adını girin",
    l96: "Ödeme bağlantısı oluşturulamadı",
    l97: "En fazla seçilebilir adet sayısına ulaşıldı",
    l98: "Seçenekler",
    l99: "Parametre hatası",
    l100: "Zorunlu alan",
    l101: "İndirim kuponu",
    l102: "Girişten sonra kullanılabilir",
    l103: "Seçildi",
    l104: "adet",
    l105: "Kullanılabilir",
    l106: "0 adet kullanılabilir",
    l107: "Kullanılamaz",
    l108: "Bu sipariş için kullanılabilir",
    l109: "Sipariş tutarı",
    l110: "Kullanılabilir",
    l111: "Gelip alma",
    l112: "Eve teslimat",
    l113: "Tam ad",
    l114: "Telefon numarası",
    l115: "Posta kodu",
    l116: "Adres",
    l117: "Teslim alma saati",
    l118: "Varış saati",
    l119: "Zorunlu seçimler",
    l120: "Sabit menü",
    l121: "İsteğe bağlı menü kalemleri",
    l122: "Bahşiş",
    l123: "Yemek fiyatı",
    l124: "Hizmet ücreti",
    l125: "Ambalaj ücreti",
    l126: "adet minimum",
    l127: "Tümü",
    l128: "Vergi dahil",
    l129: "Vergi öncesi",
    l130: "Girin",
    l131: "Özel notlar",
    l132: "Notları girin",
    l133: "Notlar",
    l134: "Tümünü seç",
    l135: "Toplam tutar",
    l136: "Sipariş ver",
    l137: "Başarıyla alındı->",
    l138: "Çözümlandı",
    l139: "Bu sayfada sadece QR kodu ile sipariş edilen yemekler gösterilir. Tam faturayı görmek için geri dönün ve sağ alttaki simgeye tıklayın.",
  },
  {
    l1: "Захиалга",
    l2: "Ресторанны телефон",
    l3: "Ишлэх цаг",
    l4: "Хэл",
    l5: "Сэлтийн дугаар",
    l6: "Хайх",
    l7: "Буцах",
    l8: "Едлэл",
    l9: "Меню",
    l10: "Хэлбэрлэх",
    l11: "Сагсанд нэмэх",
    l12: "Тийм",
    l13: "Хэлбэр",
    l14: "Нэмэлт үнэ",
    l15: "Баталгаажуулах",
    l16: "Цуцлах",
    l17: "Тэмдэглэл",
    l18: "Сагс",
    l19: "Бүхнийг сонгох",
    l20: "Захиалга",
    l21: "Устгах?",
    l22: "Холбоогүй хоол",
    l23: "Хоолны цаг",
    l24: "Хамгаал",
    l25: "Захиалгыг баталгаажуулах?",
    l26: "Хоолны сонгох",
    l27: "Хоолны тоо их",
    l28: "Хэрэв...",
    l29: "Захиалга амжилтгүй",
    l30: "Рестораныг хүлээх",
    l31: "Ресторан нь хүлээгүй",
    l32: "Сэлтийг нээхгүй",
    l33: "Сэлтийн төлбөр тооцоож байна",
    l34: "Захиалгын тоог их",
    l35: "Тоо нь их",
    l36: "Захиалгын цагаас гадна",
    l37: "Захиалгын цаг дууссан",
    l38: "Дууссан",
    l39: "Ресторан нь хүлээгүй",
    l40: "Хэлбэрлэх",
    l41: "Сонгох шаардлагатай",
    l42: "Хамгийн бага",
    l43: "Хамгийн их",
    l44: "Сонгоно уу",
    l45: "Гишүүн нэвтрэх",
    l46: "Нэвтрэх",
    l47: "Бүртгүүлэх",
    l48: "Нэрээ оруулна уу",
    l49: "Баталгаажуулах код авах",
    l50: "Имэйл оруулна уу",
    l51: "Нууц үгээ оруулна уу",
    l52: "Одоогийн гишүүний аккаунтаас гарах уу?",
    l53: "Зөв имэйл хаяг оруулна уу",
    l54: "Баталгаажуулах код оруулна уу",
    l55: "Амжилттай бүртгэгдлээ",
    l56: "Код илгээгдсэн",
    l57: "Код илгээж чадсангүй",
    l58: "Энэ имэйл бүртгэлтэй байна",
    l59: "Баталгаажуулах код буруу байна",
    l60: "Бүртгэл амжилтгүй",
    l61: "Гишүүн байхгүй эсвэл нууц үг буруу",
    l62: "Хэрэглэх боломжтой купон байхгүй",
    l63: "Элдэв гишүүнээр нэвтэрнэ үү",
    l64: "Цэвэрлэх",
    l65: "Купон сонгох",
    l66: "Дээд боломж",
    l67: "Купон",
    l68: "Хөнгөлөлт",
    l69: "Дууссан",
    l70: "И-мэйл",
    l71: "Нууц үг",
    l72: "Хэрэглэгчийн нэрийг оруулна уу",
    l73: "И-мэйл хаягийг оруулна уу",
    l74: "Баталгаажуулах кодыг оруулна уу",
    l75: "Нууц үгийг оруулна уу",
    l76: "Сонгосон",
    l77: "Сонгох",
    l78: "Амжилттай нэмэгдлээ",
    l79: "Одоохондоо ашиглаж болох хөнгөлөлтийн купон байхгүй байна",
    l80: "Зарим купоны хугацаа дууссан автоматаар устгагдлаа",
    l81: "Хамгийн их сонгож болох",
    l82: "купон",
    l83: "Захиалгын нийт дүн нь энэхүү купоны ашиглах нөхцөлд хүрэхгүй байна",
    l84: "Хөнгөлөлтийн дүн нь захиалгын дүнгээс их байж болохгүй",
    l85: "Дэлгүүрийн түлхүүр авахад алдаа гарлаа",
    l86: "Нэвтрэх амжилттай",
    l87: "Нэвтрэх амжилтгүй",
    l88: "Гишүүн хэрэглэлийн нэхэмжлэлийн дугаар байхгүй байна",
    l89: "Гишүүн хэрэглэлийг бүртгэхэд амжилтгүй",
    l90: "Дэлгүүрийн дугаар байхгүй байна",
    l91: "Дэлгүүрийн түлхүүр хоосон байна",
    l92: "Дэлгүүрийн түлхүүрийг задлахад амжилтгүй",
    l93: "Энэ хөтөч AES тайлах үйлдлийг дэмжихгүй",
    l94: "Дэлгүүрийг идэвхжүүлээгүй байна",
    l95: "Хэрэглэгчийн нэрийг оруулна уу",
    l96: "Төлбөр холбоос үүсгэхэд амжилтгүй",
    l97: "Хамгийн их сонгож болох тоо хүрч байна",
    l98: "Сонголтууд",
    l99: "Параметрийн алдаа",
    l100: "Заавар оруулах",
    l101: "Хөнгөлөлтийн купон",
    l102: "Нэвтрээд нэн дараа ашиглаж болно",
    l103: "Сонгосон",
    l104: "ш",
    l105: "Ашиглаж болно",
    l106: "0 ш ашиглаж болно",
    l107: "Ашиглаж болохгүй",
    l108: "Энэ захиалгад ашиглаж болно",
    l109: "Захиалгын дүн",
    l110: "Ашиглаж болно",
    l111: "Өөр авна",
    l112: "Хүргэлт",
    l113: "Бүтэн нэр",
    l114: "Утасны дугаар",
    l115: "Шуудангийн код",
    l116: "Хаяг",
    l117: "Хоол авсан цаг",
    l118: "Ирэх цаг",
    l119: "Заавар сонгох ёстой",
    l120: "Тогтовч цэс",
    l121: "Сонгож болох цэсийн зүйлс",
    l122: "Урамшууллын мөнгө",
    l123: "Хоолны үнэ",
    l124: "Үйлчилгээний төлбөр",
    l125: "Хайрцаглах төлбөр",
    l126: "хамгийн бага",
    l127: "Бүгд",
    l128: "Татвар орсон",
    l129: "Татвараас өмнөх",
    l130: "Оруулна уу",
    l131: "Өөрчлөлттэй тайлбар",
    l132: "Тайлбарыг оруулна уу",
    l133: "Тайлбар",
    l134: "Бүгдийг сонгох",
    l135: "Нийт дүн",
    l136: "Захиалга илгээх",
    l137: "Амжилттай авлаа->",
    l138: "Засагдсан",
    l139: "Энэ хуудас зөвхөн QR кодоор захиалсан хоолны жорыг үзүүлдэг. Бүрэн нэхэмжлэхийг харахыг хүсвэл буцаж, баруун доод буландхь icon дээр дарна уу.",
  },
]
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
Vue.use(VueAwesomeSwiper)




// WEBPACK FOOTER //
// ./src/main.js